/* ============================================================================
 * assets/mf-track.js — MOBILFOX theme event layer (Phase 1)
 * ----------------------------------------------------------------------------
 * Transport: TWO INDEPENDENT SINKS — see section 1b.
 *   A) window.dataLayer object push -> GTM-W6MQPDW (bootstrap
 *      layout/theme.liquid:194-200, noscript :328). No GTM tag consumes it
 *      today; it is kept warm as a zero-cost option. Every event carries
 *      mf_ga4_sent — any future GTM trigger on an mf_* event MUST add the
 *      exception "mf_ga4_sent equals false" or it will double-count sink B.
 *   B) GA4 G-HER8RGKKCB via a Google tag resolved at runtime: the native
 *      Google & YouTube web pixel's own window.gtag when reachable (same tag
 *      instance -> same client_id / session_id / cookies), otherwise nothing.
 *      ALWAYS with send_to: 'G-HER8RGKKCB'.
 *
 * THIS FILE IS THE ONLY PLACE THEME ANALYTICS LIVES.
 * Never add tracking inside sections/glossy-product.liquid, sections/glossy-color.liquid,
 * sections/glossy-airshock.liquid, sections/header.liquid, snippets/glossy-drawer.liquid
 * or sections/mini-cart.liquid.
 *
 * HARD PROHIBITIONS (see spec §1):
 *   - Never emit any of the 11 event names already sent by Shopify's native
 *     Google & YouTube channel (web pixel 1011319113):
 *     page_view, search, view_item_list, view_item, add_to_cart, remove_from_cart,
 *     view_cart, begin_checkout, add_shipping_info, add_payment_info, purchase.
 *   - Never bind to cart:updated / cart:refresh / cartUpdated / cart-drawer:loaded /
 *     fsb:render-ready / variant:added. One PDP add fans out to 1x cart:updated +
 *     4x cart:refresh on three different targets
 *     (sections/glossy-product.liquid:3237,:3241,:3245,:3466,:3470) and
 *     snippets/js-variables.liquid:80-82 fires cart:refresh on EVERY pageshow.
 *   - atc_submit and upsell_confirm are INTENT, not revenue:
 *     sections/glossy-product.liquid:3282-3295 and :3463-3487 never inspect
 *     response.ok and fetch() does not reject on 4xx.
 *
 * No build step exists in this theme. ES5 only: no let/const, no arrow functions,
 * no template literals, no optional chaining, no Object.assign, no Array.from.
 * Loaded with `defer` from layout/theme.liquid:191, so nothing may be assumed to
 * exist at execution time — every hook is delegated or a MutationObserver.
 * ==========================================================================*/
(function () {
  'use strict';

  var W = window;
  var D = document;
  var DE = D.documentElement;

  /* Config injected by snippets/mf-track-init.liquid. Liquid does NOT render
     inside assets/*.js — proof: assets/redirect.js:7 ships the literal
     "{{ request.path | slice: 0, 6 }}". All shop context arrives via window. */
  var CFG = (W.__mfTrack && W.__mfTrack.config) || null;

  /* ==========================================================================
     0. GUARDS — design_mode, kill switch, environment, then consent (§4)
     ========================================================================*/

  /* No config object at all => the snippet did not render (theme editor path,
     see snippets/mf-track-init.liquid). Do nothing, silently. */
  if (!CFG) { return; }

  /* Guard 1a: Liquid request.design_mode, passed in via the config object. */
  if (CFG.designMode === true) { return; }

  /* Guard 1b: runtime design mode. Matches the theme's own convention
     (assets/theme.js:281, :978, :2981). Covers editor iframes where the
     snippet rendered before the editor took over. */
  if (W.Shopify && W.Shopify.designMode) { return; }

  /* Guard 1c: kill switch. Flip CFG.enabled to false in the Liquid snippet to
     disable the whole layer with a one-word push, no JS edit. A localStorage
     override lets support kill it per-browser without a deploy. */
  if (CFG.enabled === false) { return; }
  var lsGet = function (k) {
    try { return W.localStorage ? W.localStorage.getItem(k) : null; }
    catch (e) { return null; }
  };
  if (lsGet('mf_track_off') === '1') { return; }

  /* --- environment: live vs dev (spec §4, three layers) ------------------- */
  /* Layer 3: theme role + preview_theme_id. NEVER hard-code the live theme id
     (CLAUDE.md Rule 3 allows 186358858057 in exactly one read-only pull
     command and nowhere else). `role` self-enables the day a theme is published. */
  var themeRole = 'unknown';
  try {
    if (W.Shopify && W.Shopify.theme && W.Shopify.theme.role) {
      themeRole = String(W.Shopify.theme.role);
    }
  } catch (e) {}

  var qs = String(location.search || '');
  var isPreview =
    /(^|[?&])preview_theme_id=/.test(qs) ||
    /(^|;\s*)preview_theme_id=/.test(String(D.cookie || ''));

  var forced =
    /(^|[?&])mf_track=preview(&|$)/.test(qs) ||
    lsGet('mf_track') === 'preview';

  var ENV = (themeRole === 'main' && !isPreview) ? 'live' : 'dev';

  /* Dev theme / preview is SILENT unless explicitly opted in. When opted in it
     still pushes, stamped mf_env:"dev", so the GTM blocking trigger
     (mf_env equals dev) shows the full payload in Preview with the tag blocked. */
  if (ENV === 'dev' && !forced) { return; }

  var DEBUG = forced && !!W.console && typeof W.console.log === 'function';

  /* ==========================================================================
     1. CONSENT GATE — fail closed, bounded queue, 4s watchdog (§4)
     ========================================================================*/
  var consent = null;          /* null = undecided, true = allowed, false = denied */
  var queue = [];
  var QUEUE_MAX = 60;
  var FALLBACK = (CFG.consentMode === 'mirror');   /* 'strict' (default) = fail closed */
  var consentSettled = false;

  /* ==========================================================================
     1b. TRANSPORT — two independent sinks
     --------------------------------------------------------------------------
     SINK A  window.dataLayer object push -> GTM-W6MQPDW. Unchanged behaviour.
             No GTM tag consumes it today; it is kept warm as a zero-cost
             option. Every event now also carries mf_ga4_sent (see INTERLOCK).

     SINK B  GA4 property G-HER8RGKKCB, through a Google tag resolved at runtime:
       'native'  Shopify's Google & YouTube web pixel (app 1011319113) runs with
                 runtimeContext OPEN — a plain <script> in the top window — and
                 assigns window.gtag / window.dataLayer there. Sending through it
                 is the SAME tag instance: identical client_id, session_id and
                 _ga / _ga_HER8RGKKCB cookies, zero extra network. Expected path.
       'own'     OPT-IN ONLY (CFG.ga4Fallback === true, default off). Loads
                 gtag/js ourselves into a PRIVATE data layer. Off by default
                 because a second instance of the same measurement id duplicates
                 Enhanced Measurement (scroll, outbound click, form_start,
                 video) and history-change page_view, none of which
                 send_page_view:false suppresses.
       'none'    No tag. Sink A still fires. NOT terminal — deliver() re-checks
                 on every event, so a tag that shows up late still gets used.

     WHY send_to IS MANDATORY
       The native pixel issues gtag('config', ...) for FOUR ids on this store:
       G-HER8RGKKCB, G-6ND4F2R04V, AW-879812455, GT-WKRWBPS6. Google's routing
       spec sends an event with no send_to to the "default" target group, i.e.
       every target configured before it. A bare gtag('event','mf_pdp_step',{})
       would also hit the second GA4 property, a live Google Ads account, and a
       GT- container whose onward destinations are invisible from the storefront.

     WHY AW-879812455 CANNOT BOOK A CONVERSION FROM HERE — three locks
       1. send_to pins routing to the GA4 measurement id.
       2. An Ads conversion sent by gtag is keyed by 'AW-<id>/<label>'; this
          module never constructs that form, and GA4_DENY_PARAM strips value,
          currency, transaction_id and items so a mis-imported event could never
          carry revenue. NOTE: this does NOT cover the GA4 -> Ads key-event
          import path, which is server-side and ignores send_to. Blocking that
          is an ADMIN task: no mf_* name may be marked as a GA4 key event.
       3. Name allowlist /^mf_[a-z0-9_]{1,36}$/, plus a hard denylist of the 11
          names owned by the native pixel — enforced for BOTH sinks.

     INTERLOCK — how the two sinks stay mutually exclusive
       On the native path window.gtag is dataLayer.push(arguments), so sink B's
       command lands in the SAME array GTM reads. A future GTM GA4 tag built on
       mf_pdp_step would otherwise fire twice and duplicate sink B. Therefore:
         - before a delivery we prime the model with {mf_ga4_sent:true} (no
           `event` key, so it triggers nothing, it only sets the variable);
         - the gtag command itself carries mf_ga4_sent:true in its parameters,
           so it is self-describing and does not rely on model inheritance;
         - the object push that follows carries the TRUTH (whether emit really
           handed the command to a tag).
       The single rule for any future GTM trigger on an mf_* event:
         mf_ga4_sent  equals  false
       Delivered -> flag true -> trigger blocked. Not delivered (transport
       'none', consent denied, gtag threw) -> flag false -> GTM fires and no
       gtag command was ever emitted. At most one delivery in every state.
     ========================================================================*/

  /* Idempotency. A second execution would mean two pollers and two deliver()
     calls per event, i.e. everything counted twice in both sinks. */
  if (W.__mfTrack.transportLoaded) { return; }
  W.__mfTrack.transportLoaded = 1;

  /* 2026-09-11: the measurement id is per STORE, not per build. The default is
     the Romanian property, so a theme that passes no ga4Id behaves exactly as it
     did before this line existed. A theme that passes an EMPTY string turns sink B
     off completely - the beacon still runs, GA4 does not. That is the switch a
     second market needs on day one, before anyone has decided whether its events
     belong in a shared property. */
  var GA4_ID     = (CFG.ga4Id === '' ? '' : (CFG.ga4Id || 'G-HER8RGKKCB'));
  var GA4_ON     = !!GA4_ID;
  var GA4_COOKIE = GA4_ID ? '_ga_' + GA4_ID.slice(2) : '';
  var OWN_DL     = 'mfGtagDL';                 /* private data layer, 'own' path */
  var OK_KEY     = 'mf_ga4_ok';                /* cross-page delivery watermark */
  var HEALTH_KEY = 'mf_health';

  /* The 11 names emitted by web pixel 1011319113. Re-emitting any of them
     double-counts real revenue and Google Ads conversions. Enforced in the
     transport, before BOTH sinks, so no future caller of the public push() can
     leak one — and so mf_ga4_sent:false can never invite a GTM tag to fire on
     add_to_cart or purchase. */
  var NATIVE_EVENTS = {
    page_view: 1, search: 1, view_item_list: 1, view_item: 1,
    add_to_cart: 1, remove_from_cart: 1, view_cart: 1, begin_checkout: 1,
    add_shipping_info: 1, add_payment_info: 1, purchase: 1
  };
  var MF_NAME_RE = /^mf_[a-z0-9_]{1,36}$/;

  /* Keys that must never travel to GA4 on a micro-step event. `groups` is
     stripped because it alters gtag routing and would defeat the send_to pin;
     the commerce keys are stripped so that even a mis-imported mf_* key event
     can only ever count an action, never revenue. */
  var GA4_DENY_PARAM = {
    event: 1, ecommerce: 1, gtm: 1, send_to: 1, groups: 1,
    mf_ga4_sent: 1, mf_transport: 1,
    value: 1, currency: 1, transaction_id: 1, items: 1,
    tax: 1, shipping: 1, coupon: 1, affiliation: 1
  };

  /* --- discovery budget ---------------------------------------------------
     Deliberately short. Sink A must not be held hostage to sink B's discovery
     race: everything is buffered while TRANSPORT === 'pending', so a long
     budget means a page that navigates early loses events from BOTH sinks.
     4s covers the normal pixel-manager injection; a visitor who already has the
     _ga_HER8RGKKCB cookie demonstrably runs a Google tag on this origin, so
     that case gets one 3s extension rather than a second tag. 'none' is not
     terminal, so a very late tag is still picked up by deliver(). */
  var GA_DEADLINE_MS = 4000;
  var GA_EXTEND_MS   = 3000;
  var GA_OWN_MS      = 5000;
  var GA_QUEUE_MAX   = 200;     /* EVENTS, not objects; ring, drops oldest */
  var ACK_MS         = 2500;
  var REPLAY_WIN_MS  = 60000;
  var RING_MAX       = 25;
  var HEALTH_MAX     = 10;

  var TRANSPORT     = 'pending';   /* pending | native | own | none */
  var gaQueue       = [];
  var gaQueueEvents = 0;
  var gaDeadline    = 0;
  var gaDelay       = 100;
  var gaExtended    = false;
  var settledAt     = 0;
  var lastOkWrite   = 0;
  var ECHO          = DEBUG;
  var RING          = [];
  var T0            = new Date().getTime();

  var STATS = {
    sent_ga4: 0, ack_ga4: 0, no_ack: 0, sent_dl: 0,
    dropped_ga4: 0, dropped_queue: 0, dropped_native_name: 0,
    dropped_replay_dupe: 0, errors: 0, last_error: '',
    last: '', last_at: 0
  };

  W.dataLayer = W.dataLayer || [];
  W[OWN_DL]   = W[OWN_DL] || [];

  function nowMs() { return new Date().getTime(); }
  function has(o, k) { return Object.prototype.hasOwnProperty.call(o, k); }
  function defer(fn) { try { W.setTimeout(fn, 0); } catch (e) {} }
  function fail(where, e) {
    STATS.errors++;
    STATS.last_error = where + ': ' + String((e && e.message) || e);
  }
  function ss() { try { return W.sessionStorage || null; } catch (e) { return null; } }

  /* gtag() is BY DEFINITION dataLayer.push(arguments). The Arguments object is
     what identifies a command — dataLayer.push(['event', ...]) with a real
     Array is NOT processed, and is the classic silent failure on this path. */
  function ownGtag() { W[OWN_DL].push(arguments); }

  /* Readiness = gtag exists AND the container for OUR id is registered, which
     is exactly "a command sent now will be routed". Deliberately NOT gated on
     gtag('get', ...): its callback never fires when consent is denied, so a
     timeout there is indistinguishable from success-with-no-data. */
  function nativeReady() {
    /* No measurement id configured for this store => there is nothing to be ready
       for. Returning false keeps TRANSPORT at 'none', which is the one switch sink
       B consults on every event, so GA4 stays off while sink A (dataLayer) and the
       beacon keep working normally. */
    if (!GA4_ON) { return false; }
    try {
      if (typeof W.gtag !== 'function') { return false; }
      var g = W.google_tag_manager;
      return !!(g && g[GA4_ID]);
    } catch (e) { return false; }
  }

  function hasStreamCookie() {
    try {
      return new RegExp('(^|;\\s*)' + GA4_COOKIE + '=').test(String(D.cookie || ''));
    } catch (e) { return false; }
  }

  /* Weaker "is ANY Google tag alive here" probe. Used ONLY as a veto on loading
     our own tag, never as an emit gate — send_to needs the direct G-HER8RGKKCB
     config to route. google_tag_manager is an undocumented internal, so a false
     negative from nativeReady() must degrade to 'none', never to a second
     instance of the same measurement id. */
  function anyGoogleTag() {
    try {
      var g = W.google_tag_manager, k;
      if (g) {
        for (k in g) {
          if (has(g, k) && /^(G|GT|AW|GTM)-/.test(k)) { return true; }
        }
      }
    } catch (e) {}
    return (typeof W.gtag === 'function') || hasStreamCookie();
  }

  function tagFn() {
    var fn = null;
    if (TRANSPORT === 'native') { fn = W.gtag; }
    else if (TRANSPORT === 'own') { fn = ownGtag; }
    return (typeof fn === 'function') ? fn : null;
  }

  function ga4NameAllowed(name) {
    if (!name || typeof name !== 'string') { return false; }
    if (!MF_NAME_RE.test(name)) {
      defer(function () { diag('ga4_name_rejected', name); });
      return false;
    }
    return true;
  }

  /* Cross-page delivery watermark for the stash/replay pair at :769-833.
     That insurance exists because the device picker assigns location.href on
     the statement after push(). Sink B delivers through gtag, which uses
     sendBeacon and survives unload — so the page-A copy DOES arrive, and the
     page-B replay would be a SECOND delivery of the same interaction. If a GA4
     emit succeeded within the last minute the replay is redundant and is
     dropped from both sinks.
     The watermark is read ONCE, at load, before this page can overwrite it with
     its own deliveries — otherwise this page's own heartbeat would make every
     replay look redundant and the cold case (previous page delivered nothing)
     would silently lose the event. */
  var prevOkAt = 0;
  try {
    var s1 = ss();
    if (s1) { prevOkAt = Number(s1.getItem(OK_KEY) || 0) || 0; }
  } catch (e) {}

  function markOk() {
    var t = nowMs() || 1;
    if (lastOkWrite && (t - lastOkWrite) < 1000) { return; }   /* throttle, never skip the first */
    lastOkWrite = t;
    try { var s0 = ss(); if (s0) { s0.setItem(OK_KEY, String(t)); } } catch (e2) {}
  }
  function isRedundantReplay(o) {
    if (!o || o.mf_replayed !== 'true') { return false; }
    if (prevOkAt <= 0) { return false; }        /* previous page delivered nothing */
    var age = nowMs() - prevOkAt;
    return (age < 0) || (age < REPLAY_WIN_MS);  /* negative = clock skew, treat as fresh */
  }

  /* Sink B write. Returns true only if a command was handed to a live tag. */
  function emit(name, o) {
    var fn = tagFn();
    if (!fn) { return false; }

    var p = {}, k;
    for (k in o) {
      if (!has(o, k)) { continue; }
      if (has(GA4_DENY_PARAM, k)) { continue; }
      p[k] = o[k];
    }
    p.send_to = GA4_ID;          /* MANDATORY — see header. Never remove. */
    if (TRANSPORT === 'native') { p.mf_ga4_sent = true; }   /* self-describing */

    /* DELIVERY ACK. gtag calls event_callback once the hit has been sent, and
       again after event_timeout if it could not. A callback that NEVER fires is
       the only client-side signal that the tag is present but the transport is
       dead (blocked /g/collect, killed gtag runtime). Without it "handed to
       gtag" and "arrived in GA4" are indistinguishable. */
    var acked = false;
    p.event_timeout = 2000;
    p.event_callback = function () {
      if (acked) { return; }
      acked = true; STATS.ack_ga4++;
    };
    W.setTimeout(function () {
      if (acked) { return; }
      acked = true; STATS.no_ack++;
      if (STATS.no_ack === 1) {
        defer(function () { diag('ga4_no_ack', 'callback_never_fired'); });
      }
    }, ACK_MS);

    fn('event', name, p);
    return true;
  }

  /* Final delivery to both sinks. Called only once TRANSPORT is decided. */
  function deliver(o) {
    var ev = (o && o.event) || '';

    /* A name owned by the native pixel must reach NEITHER sink: sink A shares
       window.dataLayer with any future GTM GA4 tag, and mf_ga4_sent:false is an
       explicit invitation for that tag to fire — exactly how a theme-side
       add_to_cart or purchase would end up double-counted. */
    if (ev && has(NATIVE_EVENTS, ev)) {
      STATS.dropped_native_name++;
      defer(function () { diag('native_name_blocked', ev); });
      return;
    }
    if (isRedundantReplay(o)) {
      STATS.dropped_replay_dupe++;
      return;
    }

    /* 'none' is not terminal: a slow network, a late consent grant or a CMP
       unblock can produce a tag after the deadline. One property read per event
       turns a lost session into a partially saved one. */
    if (TRANSPORT === 'none' && nativeReady()) {
      TRANSPORT = 'native';
      defer(function () { diag('transport_recovered', 'native_after_deadline'); });
    }

    /* ENV GATE — sink B is LIVE-ONLY.
       The module already returns at the top for a dev theme unless the operator
       opts in with localStorage mf_track='preview' (or ?mf_track=preview). That
       opt-in exists so we can watch the payloads while developing — it must NOT
       put our own test clicks into the production GA4 property, which is the
       exact pollution the guard at the top of this file was added to stop.
       Sink A (dataLayer) still receives everything, so preview mode remains
       fully inspectable in the console; only the GA4 hop is suppressed.
       Design note: this is deliberately checked here, per event, and not folded
       into TRANSPORT, so that a theme published later self-enables with no code
       change — ENV is derived from Shopify.theme.role at :91. */
    var willSend = false;
    try {
      willSend = !!(ENV === 'live' && ev && ga4NameAllowed(ev) && tagFn());
    } catch (e0) { fail('gate', e0); }

    /* Prime the GTM model BEFORE the gtag command lands in the shared array, so
       the interlock holds even for the first event of the pageload. No `event`
       key -> sets the variable, triggers nothing. */
    if (willSend && TRANSPORT === 'native') {
      try { W.dataLayer.push({ mf_ga4_sent: true }); } catch (e1) { fail('prime', e1); }
    }

    var sent = false;
    try {
      if (willSend) {
        sent = emit(ev, o);
        if (sent) { STATS.sent_ga4++; markOk(); }
      }
    } catch (e2) { fail('sink_b', e2); }

    /* Sink A: unchanged GTM push, now stamped with the TRUTH. If emit() threw
       after the prime, this corrects the model back to false so the
       "mf_ga4_sent equals false" exception does not swallow an event that GA4
       never received. */
    try {
      if (ev) {
        o.mf_ga4_sent  = sent;
        o.mf_transport = TRANSPORT;
        STATS.last = ev;
        STATS.last_at = nowMs();
      }
      W.dataLayer.push(o);
      if (ev) {
        STATS.sent_dl++;              /* {ecommerce:null} is not an event */
        if (!sent) { STATS.dropped_ga4++; }
        RING.push({ t: nowMs() - T0, e: ev, ga4: sent, tr: TRANSPORT });
        if (RING.length > RING_MAX) { RING.shift(); }
      }
    } catch (e3) { fail('sink_a', e3); }

    if (ECHO) {
      try {
        W.console.log('[mf]', ev || '(reset)',
                      sent ? ('-> dl + ga4/' + TRANSPORT) : ('-> dl only (' + TRANSPORT + ')'), o);
      } catch (e4) {}
    }
  }

  /* THE replacement for the old raw(): same name, same single-argument
     contract, so decide() and enqueue() are untouched. Buffering before the
     transport is resolved is what stops an early panel_expand being lost to the
     pixel-manager race; the ring drops the OLDEST event, because the newest is
     the one closest to the navigation that will destroy the queue. */
  function raw(o) {
    try {
      if (TRANSPORT === 'pending') {
        gaQueue.push(o);
        if (o && o.event) { gaQueueEvents++; }
        while (gaQueueEvents > GA_QUEUE_MAX) {
          var d = gaQueue.shift();
          if (d && d.event) { gaQueueEvents--; STATS.dropped_queue++; }
        }
        return;
      }
      deliver(o);
    } catch (e) { fail('raw', e); }   /* a tracker must never break the storefront */
  }

  function settle(mode) {
    if (TRANSPORT !== 'pending') { return; }
    TRANSPORT = mode;
    settledAt = nowMs();
    var q = gaQueue, i, drained = 0;
    gaQueue = [];
    gaQueueEvents = 0;
    for (i = 0; i < q.length; i++) {
      if (q[i] && q[i].event) { drained++; }
      deliver(q[i]);
    }
    /* Heartbeat. This is the ONLY signal that reaches GA4 on a healthy page and
       therefore the denominator for "what share of sessions could we deliver
       to". The 'none' variant cannot reach GA4 by definition — it lands in
       sink A and in the localStorage health log, which is what check() reads. */
    var summary = (settledAt - T0) + 'ms;q=' + drained + ';drop=' + STATS.dropped_queue;
    /* A health ping only has to fire when it carries news, or often enough to keep a
       denominator. Unconditionally it was one extra GA4 request on every pageview
       for the sentence "everything is fine". */
    var interesting = mode === 'none' || drained > 0 || STATS.dropped_queue > 0;
    if (interesting || Math.random() < 0.05) {
      defer(function () { diag('transport_' + mode, summary); });
    }
  }

  function pollTag() {
    try {
      if (TRANSPORT !== 'pending') { return; }
      if (nativeReady()) { settle('native'); return; }

      var t = nowMs();
      if (t < gaDeadline) {
        var nxt = gaDelay * 2;
        gaDelay = (nxt > 2500) ? 2500 : nxt;      /* cap AFTER doubling */
        var rem = gaDeadline - t;
        if (gaDelay > rem) { gaDelay = (rem < 50) ? 50 : rem; }
        W.setTimeout(pollTag, gaDelay);
        return;
      }
      if (!gaExtended && hasStreamCookie()) {
        /* The stream cookie proves a Google tag normally runs on this origin,
           so this is lateness, not absence. */
        gaExtended = true;
        gaDeadline = t + GA_EXTEND_MS;
        W.setTimeout(pollTag, 500);
        return;
      }
      startOwnTag();
    } catch (e) { fail('poll', e); settle('none'); }
  }

  function startOwnTag() {
    try {
      /* OPT-IN ONLY. Default is 'none'. Enable with ga4Fallback: true in
         snippets/mf-track-init.liquid, and only after GA4 DebugView confirms
         no duplicate Enhanced Measurement. localStorage mf_ga4_fallback=0
         kills it per browser without a deploy. */
      if (CFG.ga4Fallback !== true || lsGet('mf_ga4_fallback') === '0') {
        settle('none'); return;
      }
      /* Never race an existing Google tag: a second gtag/js for the SAME
         measurement id duplicates Enhanced Measurement and history-change
         page_view, which send_page_view:false does not suppress. */
      if (anyGoogleTag()) {
        settle('none');
        defer(function () { diag('ga4_native_late', 'own_tag_vetoed'); });
        return;
      }
      /* STRICTER THAN THE EVENT GATE, deliberately. CFG.consentMode 'mirror'
         lets events flow when the Customer Privacy API is unavailable, which is
         defensible only while we mirror a collector that is ALREADY running.
         Loading a new collector is a different act and needs an explicit grant.
         RO is EEA — anything other than a hard true means no tag. */
      if (consentAllowed() !== true) {
        settle('none');
        defer(function () { diag('ga4_fallback_blocked', 'consent_not_granted'); });
        return;
      }

      if (!GA4_ON) { return; }   /* no id, no tag - see nativeReady() */
      W[OWN_DL] = W[OWN_DL] || [];
      ownGtag('js', new Date());
      ownGtag('config', GA4_ID, {
        send_page_view: false,
        /* This branch runs on an analytics-only grant. Google Signals would
           feed GA4-based remarketing audiences consumed by AW-879812455, i.e.
           marketing processing without a marketing grant. Hard off. */
        allow_google_signals: false,
        allow_ad_personalization_signals: false
      });

      var sc = D.createElement('script');
      sc.async = true;
      /* l= keeps our commands OUT of window.dataLayer, so the 'own' path is
         invisible to GTM and the interlock stays exact. */
      sc.src = 'https://www.googletagmanager.com/gtag/js?id=' + GA4_ID + '&l=' + OWN_DL;
      sc.onload  = function () { settle('own'); };
      sc.onerror = function () { settle('none'); };
      (D.head || D.getElementsByTagName('head')[0] || D.body).appendChild(sc);

      /* Ad blockers neither fire onerror nor load. Hard stop. */
      W.setTimeout(function () {
        settle(nativeReady() ? 'native' : 'none');
      }, GA_OWN_MS);
    } catch (e) { fail('own_tag', e); settle('none'); }
  }

  function healthWrite() {
    try {
      if (!W.localStorage) { return; }
      var prev = [];
      try { prev = JSON.parse(W.localStorage.getItem(HEALTH_KEY) || '[]') || []; } catch (e0) {}
      if (Object.prototype.toString.call(prev) !== '[object Array]') { prev = []; }
      prev.push({
        at: nowMs(), tr: TRANSPORT,
        wait: settledAt ? (settledAt - T0) : -1,
        ga4: STATS.sent_ga4, ack: STATS.ack_ga4, noack: STATS.no_ack,
        dl: STATS.sent_dl, dq: STATS.dropped_queue,
        cs: (consent === null ? 'undecided' : String(consent)),
        err: STATS.last_error
      });
      if (prev.length > HEALTH_MAX) { prev = prev.slice(prev.length - HEALTH_MAX); }
      W.localStorage.setItem(HEALTH_KEY, JSON.stringify(prev));
    } catch (e) {}
  }

  /* The queue must never outlive the page. Settle with whatever is available at
     unload so pagehide-time events (upsell_abandon) and the pre-navigation
     mf_device_change reach at least sink A — and sink B too, since gtag uses
     sendBeacon and a native emit here still leaves the browser. */
  function flushOnExit() {
    if (TRANSPORT === 'pending') { settle(nativeReady() ? 'native' : 'none'); }
  }

  gaDeadline = T0 + GA_DEADLINE_MS;
  pollTag();     /* resolves on the first call when the tag is already warm */

  W.addEventListener('pagehide', flushOnExit, false);
  D.addEventListener('visibilitychange', function () {
    if (D.visibilityState === 'hidden') { flushOnExit(); healthWrite(); }
  }, false);

  /* The transport buffer sits DOWNSTREAM of the consent gate: decide(false)
     clears the consent queue but cannot see gaQueue. Without this, events
     captured while consent was undecided would still be transmitted after the
     shopper pressed reject. RO is EEA. */
  D.addEventListener('visitorConsentCollected', function () {
    try {
      if (consentAllowed() === false) {
        gaQueue = [];
        gaQueueEvents = 0;
        return;
      }
      /* Late grant: re-arm a transport that already gave up. */
      if (TRANSPORT === 'none' && consentAllowed() === true && !nativeReady()) {
        TRANSPORT = 'pending';
        gaDeadline = nowMs() + GA_DEADLINE_MS;
        gaDelay = 100;
        gaExtended = false;
        pollTag();
      }
    } catch (e) { fail('consent_evt', e); }
  }, false);

  /* --- merchant self-check: __mfTrack.check() in the browser console -------
     Reads state and sends nothing. Prints a plain-language verdict, the last
     events of this pageload, the last few pageloads, and the GA4 identity the
     events are being stitched onto. Also turns on a console echo until reload,
     so every further click prints. */
  function check() {
    var verdict;
    if (TRANSPORT === 'pending') {
      verdict = 'STARTING — still looking for the Google tag, ' + gaQueueEvents + ' event(s) buffered';
    } else if (TRANSPORT === 'none') {
      verdict = 'FAIL — no Google tag reachable, NOTHING reached GA4';
    } else if (consent === false) {
      verdict = 'BLOCKED — shopper declined tracking, nothing sent (correct behaviour)';
    } else if (STATS.ack_ga4 === 0 && STATS.no_ack >= 3) {
      /* A single missing callback is normal jitter; zero confirmations across
         several events means the tag is present but the hits never leave. */
      verdict = 'DEGRADED — ' + STATS.no_ack + ' event(s) accepted by the tag but never confirmed (ad blocker?)';
    } else if (STATS.dropped_queue > 0) {
      verdict = 'PARTIAL — ' + STATS.dropped_queue + ' event(s) dropped from the buffer';
    } else if (STATS.errors > 0) {
      verdict = 'DEGRADED — internal error: ' + STATS.last_error;
    } else if (STATS.sent_ga4 === 0) {
      verdict = 'IDLE — transport ' + TRANSPORT + ' is ready, no event fired on this page yet';
    } else {
      verdict = 'OK — ' + STATS.sent_ga4 + ' event(s) sent to ' + GA4_ID + ' via ' + TRANSPORT;
    }

    var history = [];
    try { history = JSON.parse(W.localStorage.getItem(HEALTH_KEY) || '[]') || []; } catch (e0) {}

    var out = {
      verdict: verdict,
      version: '1.1.0',
      env: ENV,
      transport: TRANSPORT,
      ga4_id: GA4_ID,
      resolved_after_ms: settledAt ? (settledAt - T0) : -1,
      consent: (consent === null ? 'undecided' : consent),
      consent_mode: CFG.consentMode,
      gtag_fn: (typeof W.gtag),
      tag_registered: nativeReady(),
      stream_cookie: hasStreamCookie(),
      queued: gaQueueEvents,
      sent_ga4: STATS.sent_ga4,
      confirmed_ga4: STATS.ack_ga4,
      unconfirmed_ga4: STATS.no_ack,
      sent_datalayer: STATS.sent_dl,
      dropped_ga4: STATS.dropped_ga4,
      dropped_queue: STATS.dropped_queue,
      dropped_native_name: STATS.dropped_native_name,
      dropped_replay_dupe: STATS.dropped_replay_dupe,
      errors: STATS.errors,
      last_error: STATS.last_error,
      last_event: STATS.last,
      recent: RING,
      history: history
    };

    ECHO = true;
    try {
      W.console.log('%c[mf-track] ' + verdict, 'font-weight:bold', out);
      W.console.log('[mf-track] echo ON until reload — interact with the page and ' +
                    'cross-check the names in GA4 DebugView.');
      var fn = tagFn();
      if (fn) {
        fn('get', GA4_ID, 'client_id', function (v) {
          W.console.log('[mf-track] client_id', v, '(' + TRANSPORT + ')');
        });
        fn('get', GA4_ID, 'session_id', function (v) {
          W.console.log('[mf-track] session_id', v, '(' + TRANSPORT + ')');
        });
      } else {
        W.console.log('[mf-track] no tag resolved — nothing is reaching GA4');
      }
    } catch (e) {}
    return out;
  }

  function decide(v) {
    if (consentSettled && consent === v) { return; }
    consentSettled = true;
    consent = v;
    if (v === true) {
      var q = queue;
      queue = [];
      for (var i = 0; i < q.length; i++) { raw(q[i]); }
    } else {
      queue = [];
    }
  }

  function consentAllowed() {
    try {
      var cp = W.Shopify && W.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') {
        return !!cp.analyticsProcessingAllowed();
      }
    } catch (e) {}
    return null; /* API absent / not ready */
  }

  /* Watchdog: without it, one blocked bundle silently drops the whole session
     with no signal. 4s then fail closed + diag. */
  var consentTimer = W.setTimeout(function () {
    if (!consentSettled) {
      decide(FALLBACK);
      diag('consent_timeout', 'api_not_ready_4s');
    }
  }, 4000);

  function settleFromApi() {
    var a = consentAllowed();
    decide(a === null ? FALLBACK : a);
  }

  if (W.Shopify && typeof W.Shopify.loadFeatures === 'function') {
    try {
      W.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function (err) {
          W.clearTimeout(consentTimer);
          if (err) { decide(FALLBACK); return; }
          settleFromApi();
        }
      );
    } catch (e) {
      W.clearTimeout(consentTimer);
      decide(FALLBACK);
    }
  } else {
    W.clearTimeout(consentTimer);
    decide(FALLBACK);
  }

  /* Fires on CHANGE only, never on attach. */
  D.addEventListener('visitorConsentCollected', function () {
    consentSettled = false;
    settleFromApi();
  }, false);

  /* ==========================================================================
     2. PUSH LAYER
     ========================================================================*/
  var SURFACE = 'global';   /* set by the PDP module when it initialises */

  function s(v) {
    /* GA4 param value limit is 100 chars. */
    if (v === null || v === undefined) { return ''; }
    return String(v).slice(0, 100);
  }

  function enqueue(o) {
    if (consent === true) { raw(o); return; }
    if (consent === null && queue.length < QUEUE_MAX) { queue.push(o); }
    /* consent === false -> dropped on the floor */
  }

  function push(name, params) {
    /* Stale-ecommerce guard (Google's documented reset). It MUST travel through
       the same queue as the event or ordering inverts after a consent flush. */
    enqueue({ ecommerce: null });

    var o = {
      event: name,
      /* Which store. Shopify's native Google channel already points more than one
         market at the same GA4 property, so without this an mf_* event from
         Budapest is indistinguishable from one from Bucharest. */
      mf_shop: s(CFG.shop),
      mf_env: ENV,
      mf_surface: SURFACE,
      mf_template: s(CFG.templateName),
      mf_template_suffix: s(CFG.templateSuffix),
      mf_product_handle: s(CFG.productHandle),
      mf_viewport: viewportClass()
    };
    if (params) {
      for (var k in params) {
        if (Object.prototype.hasOwnProperty.call(params, k)) { o[k] = params[k]; }
      }
    }
    if (name === 'mf_case_add' && params && params.mf_case_type) {
      sessionCaseType = String(params.mf_case_type);
    }
    if (beaconTap) { try { beaconTap(name, params); } catch (e) {} }
    enqueue(o);
  }

  /* Screen class on EVERY event, computed at push time rather than once at boot:
     a rotation or a resized desktop window changes the answer, and an event sent
     after that should say what was true when it happened. Breakpoints match the
     theme's own (assets/theme.css and the sections' media queries). */
  var beaconTap = null;      /* set by initSessionBeacon once a URL is configured */
  /* 3-letter surface code for dimensioning (menu labels, nav layer). The server
     slug charset is [A-Za-z0-9 ._-], so '.' is the only safe separator. */
  var NAV_SFC = ({ index: 'hom', collection: 'plp', search: 'srh', product: 'pdp' })[s(CFG.pageType)] || 'oth';
  var scrollBest = 0;        /* deepest point reached, in percent */
  var sessionCaseType = '';  /* last case type actually added to the cart */
  var galleryMax = 0;        /* deepest gallery position actually looked at */
  var blocksSeen = [];       /* page blocks that actually entered the viewport */
  var menuLabels = [];       /* menu rows clicked, in order */
  var menuPos = [];          /* menu-order experiment: label + level + slot */
  var menuDesigns = [];      /* design tiles clicked from inside the menu */

  function viewportClass() {
    try {
      var w = W.innerWidth || 0;
      if (!w) { return 'unknown'; }
      if (w < 768) { return 'mobile'; }
      if (w < 1024) { return 'tablet'; }
      return 'desktop';
    } catch (e) { return 'unknown'; }
  }

  /* --- runtime alarms: once per code per pageload (§4, spec §2) ----------- */
  var diagSent = {};
  function diag(code, reason) {
    if (diagSent[code]) { return; }
    diagSent[code] = 1;
    push('mf_diag', { mf_code: s(code), mf_reason: s(reason || '') });
  }

  /* --- generic per-event dedupe -------------------------------------------
     Protects against: the mini-cart innerHTML rebuild (assets/theme.js:5891-5930),
     the 4x cart:refresh fan-out re-running theme init, double-bubbled label
     clicks, and MutationObserver storms from the scroll handler
     (sections/glossy-product.liquid:3777-3792). */
  var onceKeys = {};
  function once(key) {
    if (onceKeys[key]) { return false; }
    onceKeys[key] = 1;
    return true;
  }
  var lastFire = {};
  function throttled(key, ms) {
    var now = new Date().getTime();
    if (lastFire[key] && (now - lastFire[key]) < ms) { return true; }
    lastFire[key] = now;
    return false;
  }

  function uid(prefix) {
    return prefix +
      new Date().getTime().toString(36) +
      Math.random().toString(36).slice(2, 7);
  }

  function closest(node, sel) {
    if (!node) { return null; }
    if (node.closest) { return node.closest(sel); }
    /* Fallback for very old Safari: no Element.closest. */
    var el = (node.nodeType === 1) ? node : node.parentElement;
    while (el) {
      if (el.matches ? el.matches(sel) :
          (el.msMatchesSelector && el.msMatchesSelector(sel))) { return el; }
      el = el.parentElement;
    }
    return null;
  }

  /* Public, namespaced API. NEVER a two-character global — this store runs
     Klaviyo, OptiMonk, UpPromote, dCart, Recart, Discount Ninja + 15 pixels. */
  W.__mfTrack.api = {
    push: push,
    diag: diag,
    check: check,
    transport: function () { return TRANSPORT; },
    env: ENV,
    version: '1.1.0'
  };

  /* Merchant self-check, one line in the browser console:  __mfTrack.check()  */
  W.__mfTrack.check = check;

  /* ==========================================================================
     3. PDP BUY-PANEL + UPSELL MICRO-FUNNEL  (merchant priority flow)
     ------------------------------------------------------------------------
     Scoped HARD to sections/glossy-product.liquid (templates/product.json).
     #upsellItems collides with sections/daily-drop.liquid:207;
     .sw collides with daily-drop:774, glossy-airshock:1533, glossy-color:1499;
     #gpTypes collides with glossy-airshock:1090.
     Every selector below is resolved through `sticky` and validated with
     sticky.contains(). [data-glossy-section] is NOT a discriminator — it is on
     all three forks (glossy-product:1816, glossy-airshock:1022, glossy-color:983).
     ========================================================================*/
  function initPdpFunnel() {

    /* sections/glossy-product.liquid:1840 — <aside id="gpSticky" class="glossy-product__sticky-atc">
       The whole dock is optional: it only exists if the section has a block of
       type 'sticky_atc' (sections/glossy-product.liquid:1818-1819). */
    var sticky = D.getElementById('gpSticky');
    if (!sticky) { return; }

    /* FORK GATE (blocking, spec §4).
       All three forks emit #gpSticky (glossy-product:1840, glossy-color:1007,
       glossy-airshock:1046) and all three populate #gpCta.dataset.variantId.
       On glossy-color:1619-1622 and glossy-airshock:1647-1650 the CTA shows the
       upsell and RETURNS WITHOUT A CART CALL — which inverts atc_submit and makes
       upsell_decline the conversion. Only templates/product.json (empty suffix)
       runs sections/glossy-product.liquid. */
    if (CFG.templateName !== 'product' || CFG.templateSuffix !== '') { return; }

    /* sections/glossy-product.liquid:1976 — <script id="gpUpsellConfig" type="application/json">
       Parsed by the theme at :2509. */
    var cfgEl = D.getElementById('gpUpsellConfig');
    var upCfg = null;
    if (cfgEl) {
      try {
        upCfg = JSON.parse(cfgEl.textContent || cfgEl.innerHTML || 'null');
      } catch (e) {
        diag('cfg_parse_fail', e && e.message);
      }
    }

    /* alternate_upsell_view is TRUE live (templates/product.json:221), which
       selects the CHECKBOX renderer at sections/glossy-product.liquid:3560-3716.
       The button renderer after `} else {` at :3718 is DEAD CODE — never bind to
       button.up__opt. The section schema DEFAULT at :4847-4850 is false, so a
       theme-editor save can flip it: if that happens every checkbox hook goes
       silently to zero and the answer to "protector vs not" inverts. Alarm + bail. */
    var altView = !!(upCfg && upCfg.alternateUpsellView === true);
    if (upCfg && upCfg.enableUpsell && !altView) {
      diag('alt_view_off', 'button_renderer_would_be_live');
      return;
    }

    SURFACE = 'pdp_glossy';

    /* Eligibility replicates sections/glossy-product.liquid:3214 EXACTLY.
       Absence of #gpUpsellConfig is NORMAL, not an alarm: the element only
       renders inside {%- if inNano or inPro -%} (:1969), and the title-match
       scans at :13-32 silently drop the upsell for a title typo or an
       out-of-stock protector. Report as mf_has_upsell=false. */
    var eligible = !!(upCfg && upCfg.enableUpsell && upCfg.products &&
                      (upCfg.products.nano || upCfg.products.pro));

    /* sections/glossy-product.liquid:1852 — <button id="gpMicroCta" class="bm-cta">
       The twin at :2010 is inside {% comment %} :2001-2011 and never renders.
       If it is ever uncommented, panel_expand route attribution breaks. */
    if (!D.getElementById('gpMicroCta')) { diag('micro_cta_missing', ''); }

    /* checkOutOfStock() sections/glossy-product.liquid:3801-3822 disables #gpCta
       (:3818) but NEVER #gpMicroCta — so panel_expand can fire on a product where
       atc_submit is structurally impossible. Carry the flag on every step. */
    function isOos() {
      var c = D.getElementById('gpCta');   /* :2031 */
      if (!c) { return false; }
      return !!(c.disabled || (c.className && c.className.indexOf('out-of-stock') > -1));
    }

    var STEP_IX = {
      pdp_view: 0, panel_expand: 1, atc_blocked: 1, atc_submit: 2,
      upsell_view: 3, upsell_toggle: 3, upsell_confirm: 4, upsell_decline: 4,
      upsell_dismiss: 4, upsell_aborted: 4, upsell_abandon: 4
    };

    var F = null;                 /* current funnel instance */
    var impressionCount = 0;      /* upsell impressions this pageload */
    var pendingRoute = '';        /* open-route intent, 500ms TTL */
    var pendingRouteAt = 0;
    var ROUTE_TTL = 500;
    var abandonSent = false;
    var sawUpsellClick = false;   /* distinguishes upsell_aborted from a real resolve */

    function newFunnel(route) {
      F = {
        id: uid('f'),
        route: route || 'implicit',
        openedAt: new Date().getTime(),
        upsellAt: 0,
        toggles: 0,
        resolved: true,
        base: null,
        cur: { case_type: '', color: '', protection_mode: '' },
        counts: { case_type: 0, color: 0, protection_mode: 0 }
      };
      abandonSent = false;
      return F;
    }

    function step(name, extra) {
      var o = {
        mf_step: name,
        mf_step_index: STEP_IX[name] || 0,
        mf_funnel_id: F ? F.id : '',
        mf_has_upsell: eligible ? 'true' : 'false',
        mf_impression: impressionCount,
        mf_oos: isOos() ? 'true' : 'false'
      };
      if (extra) {
        for (var k in extra) {
          if (Object.prototype.hasOwnProperty.call(extra, k)) { o[k] = extra[k]; }
        }
      }
      push('mf_pdp_step', o);
    }

    /* ---- pdp_view: Q1 denominator. Once per pageload, this fork only. ----- */
    if (once('pdp_view')) {
      step('pdp_view', {});
    }

    /* ---- option state readers -------------------------------------------
       #gpTypes (:1961) and #gpSw (:1965) are EMPTY in Liquid and populated at
       runtime, then innerHTML-wiped again on every upstream change
       (types.innerHTML='' :2626, sw.innerHTML='' :2968,
        existingContainer.remove() :2865). Never bind to their children. */
    function readOptions() {
      /* card.dataset.caseType written at sections/glossy-product.liquid:2776 */
      var t = sticky.querySelector('#gpTypes .tcard.on');
      /* swatch.dataset.color written at sections/glossy-product.liquid:2991 */
      var c = sticky.querySelector('#gpSw .sw.on');
      /* .tcard-subvariant-btn has NO data-* attribute — the only identity is
         textContent: 'Standard' at :2894, 'MagSafe' at :2919. Absent => the
         product has a single case type and renderSubVariantButtons returned
         early at :2880-2882; that absence is itself a finding, not a drop-off. */
      var p = sticky.querySelector('.tcard-subvariant-btn.active');
      return {
        case_type: t ? s(t.getAttribute('data-case-type')) : '',
        color: c ? s(c.getAttribute('data-color')) : '',
        protection_mode: p ? s((p.textContent || '').replace(/^\s+|\s+$/g, '')) : 'n/a'
      };
    }

    /* Baseline is captured at is-open, NEVER at DOMContentLoaded.
       startInit() fires the synthetic caseTypeBtn.click() at :3845 and, inside a
       50ms setTimeout, colorBtn.click() at :3853 — so poll rather than read once.
       Hold the funnel BY REFERENCE and abort if it was replaced (close+reopen
       inside the poll window). */
    function captureBaseline(inst, tries) {
      if (!inst || inst !== F || inst.base) { return; }
      var o = readOptions();
      if ((!o.case_type || !o.color) && tries < 12) {
        W.setTimeout(function () { captureBaseline(inst, tries + 1); }, 50);
        return;
      }
      inst.base = o;
      inst.cur = {
        case_type: o.case_type,
        color: o.color,
        protection_mode: o.protection_mode
      };
      if (!o.case_type && !o.color) {
        /* Normal on an out-of-stock product: :3835 skips the synthetic clicks. */
        diag('baseline_empty', isOos() ? 'oos' : 'render_timeout');
      }
    }

    function devMask() {
      if (!F || !F.base) { return 'unknown'; }
      var keys = ['case_type', 'protection_mode', 'color'];
      var out = [];
      for (var i = 0; i < keys.length; i++) {
        if (F.cur[keys[i]] !== F.base[keys[i]]) { out.push(keys[i]); }
      }
      return out.length ? out.join(',') : 'none';
    }

    function onOption(opt, to) {
      if (!F || !to) { return; }
      var from = F.cur[opt];
      if (to === from) { return; }              /* not a change */
      F.counts[opt]++;
      F.cur[opt] = to;
      push('mf_pdp_option_change', {
        mf_option: opt,
        mf_from: s(from),
        mf_to: s(to),
        mf_default: F.base ? s(F.base[opt]) : '',
        mf_is_default: (F.base && to === F.base[opt]) ? 'true' : 'false',
        mf_change_count: F.counts[opt],
        mf_funnel_id: F.id,
        mf_impression: impressionCount
      });
      /* COLOUR RE-BASELINE TRAP: a case_type or protection_mode change wipes
         #gpSw (:2968) and the theme auto-selects the first colour with NO click
         (:3008-3016). Without this resync the next real swatch click reports a
         deviation from a colour the shopper never chose. Our listener is
         capture-phase, i.e. it runs BEFORE the theme handler — defer to task 0. */
      if (opt !== 'color') {
        var inst = F;
        W.setTimeout(function () {
          if (F && F === inst) { F.cur.color = readOptions().color; }
        }, 0);
      }
    }

    function currentChoice() {
      /* #upsellItems sections/glossy-product.liquid:1971. syncDataAttributes
         writes the STRING 'true'/'false' at :3611-3614. The theme reads exactly
         these two at :3262-3263. sticky.contains() rejects daily-drop's twin
         (sections/daily-drop.liquid:207). */
      var box = D.getElementById('upsellItems');
      if (!box || !sticky.contains(box)) { return 'none'; }
      var n = box.getAttribute('data-selected-nano') === 'true';
      var p = box.getAttribute('data-selected-pro') === 'true';
      if (n && p) { return 'both'; }   /* cart builder :3266-3279 pushes both */
      if (n) { return 'nano'; }
      if (p) { return 'pro'; }
      return 'none';
    }

    function addonPrice(choice) {
      if (choice === 'none' || choice === 'both') { return 0; }
      if (upCfg && upCfg.products && upCfg.products[choice] &&
          typeof upCfg.products[choice].price === 'number') {
        return upCfg.products[choice].price;   /* minor units */
      }
      return 0;
    }

    /* ---- state machine: MutationObserver on #gpSticky class ---------------
       This is the ONLY reliable expand hook. #gpCta is NOT valid: CSS
       sections/glossy-product.liquid:1169-1171 sets display:none on every direct
       child of #gpSticky except .buy__micro / .buy__foot whenever the dock lacks
       both is-open and is-upsell, so the self-open branch at :3200-3203 is
       unreachable by a real click. is-open is added at :3202, :3209 and :3360;
       is-upsell is added at exactly one site, :3227, and removed at :3186,
       :3372, :3482, :3537, :3548. */
    if (W.MutationObserver) {
      var prevOpen = sticky.className.indexOf('is-open') > -1;
      var prevUps = sticky.className.indexOf('is-upsell') > -1;

      new W.MutationObserver(function () {
        var cn = sticky.className || '';
        var open = cn.indexOf('is-open') > -1;
        var ups = cn.indexOf('is-upsell') > -1;

        /* DEDUPE: the scroll handler at :3777-3792 adds/removes 'hidden' on this
           same element on every frame. Bail unless membership actually changed. */
        if (open === prevOpen && ups === prevUps) { return; }

        if (open && !prevOpen && !ups && !prevUps) {
          /* Real panel open. The `!ups && !prevUps` guard kills the STALE-UPSELL
             edge case: the info link at :3414-3424 removes is-open (:3419) but
             leaves is-upsell set, so a later #gpMicroCta press re-adds is-open
             (:3360) WITHOUT re-running initializeUpsell — not a new funnel. */
          var route = 'implicit';
          if (pendingRoute &&
              (new Date().getTime() - pendingRouteAt) < ROUTE_TTL) {
            route = pendingRoute;
          }
          pendingRoute = '';
          newFunnel(route);
          captureBaseline(F, 0);
          var d = readOptions();
          step('panel_expand', {
            mf_open_route: s(route),
            mf_default_case_type: d.case_type,
            mf_default_color: d.color,
            mf_default_protection: d.protection_mode
          });
        }

        if (ups && !prevUps) {
          /* sole add site: sections/glossy-product.liquid:3227 */
          if (!F) { newFunnel('implicit'); }
          impressionCount++;
          F.upsellAt = new Date().getTime();
          F.resolved = false;
          abandonSent = false;
          sawUpsellClick = false;
          step('upsell_view', { mf_dwell_ms: F.upsellAt - F.openedAt });

          /* Renderer alarm: if the dead button branch (:3718-3773) ever goes
             live, #upsellItems holds .up__opt and no input.up__checkbox. */
          W.setTimeout(function () {
            var box = D.getElementById('upsellItems');
            if (!box || !sticky.contains(box)) {
              diag('upsell_items_missing', '');
              return;
            }
            if (!box.querySelector('input.up__checkbox') &&
                box.querySelector('.up__opt')) {
              diag('button_renderer_live', '');
            }
          }, 400);
        }

        if (!ups && prevUps) {
          /* is-upsell went away. If no upsell click preceded it, the removal
             came from :3482 / :3537 (a non-skipDrawer addToCart) or some other
             path — record it so the Q2 subtraction stays balanced. */
          if (F && !F.resolved && !sawUpsellClick) {
            F.resolved = true;
            step('upsell_aborted', {
              mf_reason: 'class_removed_no_click',
              mf_choice: currentChoice(),
              mf_dwell_ms: F.upsellAt ? (new Date().getTime() - F.upsellAt) : 0
            });
          }
        }

        prevOpen = open;
        prevUps = ups;
      }).observe(sticky, {
        attributes: true,
        attributeFilter: ['class'],
        attributeOldValue: true
      });
    } else {
      diag('no_mutationobserver', '');
    }

    /* ---- CAPTURE-phase click delegate -----------------------------------
       Capture is MANDATORY. #gpHandle (:3186-3187) and #gpX (:3370-3372) strip
       is-upsell synchronously inside listeners bound directly on the element, so
       a bubble-phase listener always reads is-upsell === false and would record
       ZERO dismissals. Capture also lets us read the pre-mutation .on / .active
       classes, which is exactly the "was it already selected" test. */
    DE.addEventListener('click', function (e) {
      /* (b) MANDATORY. startInit fires caseTypeBtn.click() at :3845 and
         colorBtn.click() at :3853 on EVERY pageload; without this every PDP view
         emits a phantom case_type AND color change and option engagement reads
         ~100%. clickFirstSwatch() at :2959-2962 is dead code (never invoked). */
      if (!e.isTrusted) { return; }
      var t = e.target;
      if (!t) { return; }

      /* Second statement: scope check. Without it every tap anywhere on the site
         walks the tree seven times ahead of every theme handler. */
      if (!sticky.contains(t)) { return; }

      var el;

      /* -- open route intent (sections/glossy-product.liquid:1852, handler :3358-3361) -- */
      if ((el = closest(t, '#gpMicroCta'))) {
        pendingRoute = 'micro_cta';
        pendingRouteAt = new Date().getTime();
        return;
      }

      /* -- dismiss: checked BEFORE the plain-handle open route --------------
         #gpHandle :1868 (handler :3183-3192), #gpX :1867 (handler :3367-3374).
         The #gpX handler is UNCONDITIONAL — it removes is-open and is-upsell
         regardless of state — so it also fires on ordinary panel closes. The
         is-upsell gate is mandatory or plain closes inflate dismissals. */
      if ((el = closest(t, '#gpHandle')) || (el = closest(t, '#gpX'))) {
        var inUpsell = sticky.className.indexOf('is-upsell') > -1;
        if (inUpsell) {
          sawUpsellClick = true;
          if (F) { F.resolved = true; }
          step('upsell_dismiss', {
            mf_dismiss_route: el.id === 'gpX' ? 'close_x' : 'handle',
            mf_choice: currentChoice(),
            mf_toggles: F ? F.toggles : 0,
            mf_dwell_ms: (F && F.upsellAt) ? (new Date().getTime() - F.upsellAt) : 0
          });
        } else if (el.id === 'gpHandle' &&
                   sticky.className.indexOf('is-open') === -1) {
          /* toggle-open route, sections/glossy-product.liquid:3190. Note CSS
             :1169-1171 hides #gpHandle while collapsed, so this is rare. */
          pendingRoute = 'handle';
          pendingRouteAt = new Date().getTime();
        }
        return;
      }

      /* -- add to cart: #gpCta sections/glossy-product.liquid:2031 ---------- */
      if ((el = closest(t, '#gpCta'))) {
        /* :3201-3204 self-open branch — unreachable through CSS, but cheap to
           exclude so a future CSS change cannot turn it into a phantom submit. */
        if (sticky.className.indexOf('is-open') === -1) { return; }
        /* dataset.variantId is written by updateDisplay at :3122 and read at :3206. */
        var vid = el.getAttribute('data-variant-id') || '';
        if (!vid) {
          /* :3207-3210 — handler re-opens the dock and returns, NO cart call. */
          if (!throttled('atc_blocked', 500)) {
            step('atc_blocked', { mf_reason: 'no_variant' });
          }
          return;
        }
        /* DEDUPE: rapid double-tap on a fixed dock button is common on mobile. */
        if (throttled('atc_submit', 800)) { return; }
        /* promoEnabled is emitted into #gpUpsellConfig at :1989; when true the
           handler takes addMultipleToCart([variantId, promoVariantId]) at :3219,
           which posts TWO line items. */
        var promo = !!(upCfg && upCfg.promoEnabled && upCfg.promoVariantId);
        step('atc_submit', {
          mf_variant_id: s(vid),
          mf_dev_mask: devMask(),
          mf_promo: promo ? 'true' : 'false',
          mf_items: promo ? 2 : 1
        });
        return;
      }

      /* -- upsell confirm / decline: SAME element, outcome from dataset ------
         #gpUpsellSkip :1972, single listener :3256, outcome decided at :3266 by
         #upsellItems.dataset (written by syncDataAttributes :3611-3614) and
         mirrored by the .has-items class (added :3606, removed :3588).
         updateSkipButton rewrites the label, so a listener that only counts
         clicks merges conversion and rejection into one meaningless number. */
      if ((el = closest(t, '#gpUpsellSkip'))) {
        if (throttled('upsell_resolve', 800)) { return; }
        sawUpsellClick = true;
        var choice = currentChoice();
        if (choice === 'both') { diag('both_selected', ''); }
        if (F) { F.resolved = true; }
        step(choice === 'none' ? 'upsell_decline' : 'upsell_confirm', {
          mf_choice: choice,
          /* INTENT, never revenue: the promise chain at :3282-3295 never checks
             response.ok and fetch does not reject on 4xx, so the success tail
             at :3297-3327 runs even on a 422 sold-out. Param is deliberately
             NOT named `value`. */
          mf_addon_price: addonPrice(choice),
          mf_has_items: (el.className.indexOf('has-items') > -1) ? 'true' : 'false',
          mf_toggles: F ? F.toggles : 0,
          mf_dwell_ms: (F && F.upsellAt) ? (new Date().getTime() - F.upsellAt) : 0
        });
        return;
      }

      /* -- option deviation --------------------------------------------------
         #gpTypes .tcard created at :2773-2777 (dataset.caseType :2776).
         The theme's own handler is wrapped in
         `if (!card.classList.contains('on'))` at :2813 — the DOM click still
         bubbles but NOTHING changes, so we must apply the same test ourselves. */
      if ((el = closest(t, '#gpTypes .tcard'))) {
        if (el.className.indexOf('on') > -1) { return; }
        onOption('case_type', s(el.getAttribute('data-case-type')));
        return;
      }
      /* #gpSw .sw created at :2989-2994 (dataset.color :2991). The theme has NO
         already-selected guard here (:2996-3003 runs unconditionally) — we add it. */
      if ((el = closest(t, '#gpSw .sw'))) {
        if (el.className.indexOf('on') > -1) { return; }
        onOption('color', s(el.getAttribute('data-color')));
        return;
      }
      /* .tcard-subvariant-btn: created :2888-2894 (Standard) / :2913-2919
         (MagSafe). Buttons with zero available variants get .disabled instead of
         a listener (:2898, :2922-2923) and emit no theme-side change. */
      if ((el = closest(t, '.tcard-subvariant-btn'))) {
        if (el.disabled || el.className.indexOf('active') > -1) { return; }
        onOption('protection_mode', s((el.textContent || '').replace(/^\s+|\s+$/g, '')));
        return;
      }
    }, true);   /* <-- CAPTURE */

    /* ---- BUBBLE-phase change delegate for the upsell checkboxes -----------
       Bubble, not capture: the theme's own change handlers (:3648 nano,
       :3697 pro) run mutual exclusion and syncDataAttributes (:3611-3614) during
       the target phase, so by the time this fires the container dataset is
       authoritative.
       'change', NOT 'click': the input is WRAPPED by label.up__opt-checkbox
       (:3619 + :3645), so one user tap bubbles TWO click events to
       documentElement. Also note the mutual exclusion at :3652 / :3701 assigns
       .checked by PROPERTY, which fires no change event — so mf_toggles counts
       DECISIONS, not state flips. */
    DE.addEventListener('change', function (e) {
      if (!e.isTrusted) { return; }
      var cb = e.target;
      if (!cb || cb.tagName !== 'INPUT') { return; }
      if (!cb.className || cb.className.indexOf('up__checkbox') === -1) { return; }
      /* Rejects sections/daily-drop.liquid:207's twin #upsellItems. */
      if (!sticky.contains(cb)) { return; }
      var box = closest(cb, '#upsellItems');
      if (!box) { return; }
      if (F) { F.toggles++; }
      step('upsell_toggle', {
        mf_option: s(cb.value),          /* 'nano' :3624 | 'pro' :3673 */
        mf_to: cb.checked ? 'on' : 'off',
        mf_choice: currentChoice()
      });
    }, false);  /* <-- BUBBLE */

    /* ---- device picker: #gpSel sections/glossy-product.liquid:1931 --------
       change handler :2615-2618 assigns window.location.href on the NEXT
       statement (:2617) — a full navigation, with no delay, no event_callback
       and no beacon. Capture phase buys the entire synchronous window; the
       sessionStorage replay below covers the case where GTM has not flushed. */
    var REPLAY_KEY = 'mf_replay';

    function stash(o) {
      try {
        if (!W.sessionStorage) { return; }
        var arr = [];
        var cur = W.sessionStorage.getItem(REPLAY_KEY);
        if (cur) { arr = JSON.parse(cur) || []; }
        if (arr.length < 10) { arr.push(o); }
        W.sessionStorage.setItem(REPLAY_KEY, JSON.stringify(arr));
      } catch (err) {}
    }

    DE.addEventListener('click', function (e) {
      if (!e.isTrusted) { return; }
      var el = closest(e.target, '#gpSel');
      if (!el || !sticky.contains(el)) { return; }
      if (!once('device_open')) { return; }   /* one 'open' per pageload */
      push('mf_device_change', {
        mf_action: 'open',
        mf_from: s(CFG.productHandle),
        mf_to: '',
        mf_options: el.options ? el.options.length : 0,
        mf_funnel_id: F ? F.id : ''
      });
    }, true);

    DE.addEventListener('change', function (e) {
      if (!e.isTrusted) { return; }
      var sel = e.target;
      if (!sel || sel.id !== 'gpSel') { return; }
      if (!sticky.contains(sel)) { return; }
      /* initDeviceSelector force-selects options[0] at :2605-2608 regardless of
         the product on screen (and BEFORE the listener is attached at :2614), so
         the select's own value is NOT a reliable "from" — use the handle. */
      var opt = (sel.options && sel.selectedIndex >= 0) ? sel.options[sel.selectedIndex] : null;
      var payload = {
        mf_action: 'change',
        mf_from: s(CFG.productHandle),
        mf_to: s(sel.value),
        mf_to_label: s(opt ? opt.text : ''),
        mf_options: sel.options ? sel.options.length : 0,
        mf_funnel_id: F ? F.id : ''
      };
      push('mf_device_change', payload);
      /* Replay insurance: navigation happens on the very next statement. */
      stash({ event: 'mf_device_change', params: payload });
    }, true);

    /* Replay anything stashed just before a navigation. */
    (function replay() {
      try {
        if (!W.sessionStorage) { return; }
        var cur = W.sessionStorage.getItem(REPLAY_KEY);
        if (!cur) { return; }
        W.sessionStorage.removeItem(REPLAY_KEY);
        var arr = JSON.parse(cur) || [];
        for (var i = 0; i < arr.length; i++) {
          if (!arr[i] || !arr[i].event) { continue; }
          var p = arr[i].params || {};
          p.mf_replayed = 'true';
          push(arr[i].event, p);
        }
      } catch (err) {}
    })();

    /* ---- abandonment (best effort) ---------------------------------------
       There is NO theme hook for this: closeUpsell() (:3547) is only ever called
       from the #gpUpsellSkip handler (:3298, :3330, :3337).
       The REPORTED number is the funnel subtraction
       upsell_view - (confirm + decline + dismiss + aborted) at mf_impression=1;
       this event exists to carry mf_choice, i.e. "abandoned with a protector
       ticked" vs "abandoned untouched".
       F.resolved is required because closeUpsell() sits inside the fetch .then()
       (:3295-3298): backgrounding during the POST would otherwise emit confirm
       AND abandon for the same funnel. */
    var provisional = false;

    function maybeAbandon(terminal) {
      if (abandonSent) { return; }
      if (!F || F.resolved) { return; }
      if (sticky.className.indexOf('is-upsell') === -1) { return; }
      if (!terminal) { provisional = true; return; }
      abandonSent = true;
      step('upsell_abandon', {
        mf_choice: currentChoice(),
        mf_toggles: F.toggles,
        mf_dwell_ms: F.upsellAt ? (new Date().getTime() - F.upsellAt) : 0
      });
    }

    D.addEventListener('visibilitychange', function () {
      if (D.visibilityState === 'hidden') { maybeAbandon(false); }
      else { provisional = false; }   /* revocable: they came back */
    }, false);

    W.addEventListener('pagehide', function () { maybeAbandon(true); }, false);

    /* bfcache restore — proven live by snippets/js-variables.liquid:80.
       Reset the latch and re-key the funnel so a restored page cannot re-emit. */
    W.addEventListener('pageshow', function (ev) {
      if (ev && ev.persisted) {
        abandonSent = false;
        provisional = false;
        if (F) { F.id = uid('f'); }
      }
    }, false);
  }

  /* ==========================================================================
     4. MENU / GLOSSY DRAWER  (global — header is rendered once at
        layout/theme.liquid:259, guarded at :253)
     ------------------------------------------------------------------------
     Every theme handler here lives inside a non-exporting IIFE
     (snippets/glossy-drawer.liquid:538-603), so nothing can be wrapped —
     delegation only. Bubble phase is fine: no handler mutates the state we read.
     ========================================================================*/
  function initMenu() {
    var openCount = 0;
    var interactions = 0;
    var openedAt = 0;
    var openId = '';
    var isOpen = false;

    function mstep(name, extra) {
      var o = {
        mf_step: name,
        mf_open_id: openId,
        mf_interaction_count: interactions,
        mf_impression: openCount
      };
      if (extra) {
        for (var k in extra) {
          if (Object.prototype.hasOwnProperty.call(extra, k)) { o[k] = extra[k]; }
        }
      }
      push('mf_menu_step', o);
    }

    DE.addEventListener('click', function (e) {
      if (!e.isTrusted) { return; }
      var t = e.target;
      if (!t) { return; }
      var el;

      /* -- open: sections/header.liquid:204 (guard has_glossy_drawer :203).
            Single markup site theme-wide; the theme binds it non-delegated at
            snippets/glossy-drawer.liquid:540/:567. -- */
      if ((el = closest(t, '[data-glossy-drawer-open]'))) {
        if (throttled('menu_open', 400)) { return; }
        openCount++;
        interactions = 0;
        openedAt = new Date().getTime();
        openId = uid('m');
        isOpen = true;
        mstep('menu_open', {});
        return;
      }

      if (!isOpen) {
        /* Everything below only makes sense inside an open drawer. */
        if (!closest(t, '[data-glossy-drawer]')) { return; }
      }

      /* -- expand: snippets/glossy-drawer.liquid:457 (level 2, inside the root
            view opened at :416) and :499 (level 3, inside the level-2 view
            opened at :491). Handler :570-576, label from data-view-name (:573).
            LEVEL TEST: the parent view's data-view. NEVER split data-view-name
            on '-' — :499 joins two admin-authored titles that may contain
            hyphens. -- */
      if ((el = closest(t, '[data-glossy-menu-expand]'))) {
        interactions++;
        var view = closest(el, '.glossy-drawer-view');
        var parentView = view ? (view.getAttribute('data-view') || '') : '';
        /* the position experiment MUST see expand buttons too: three of the
           eight root items - the pinned Choose by device among them - are
           submenu parents, and skipping them zeroed the headline curve's
           numerator and depressed slots 1-3 (verified in review) */
        var exMain = parentView === 'root';
        var exPos = parseInt(el.getAttribute('data-mx-pos') || '0', 10) || 0;
        push('mf_menu_step', { mf_step: exMain ? 'click_main' : 'click_sub' });
        if (exMain && exPos) { push('mf_menu_step', { mf_step: 'click_p' + Math.min(exPos, 15) }); }
        if (menuPos.length < 6) {
          menuPos.push(s((el.textContent || '').replace(/^\s+|\s+$/g, '')).slice(0, 18) +
            '.' + (exMain ? 'M' : 'S') + (exMain && exPos ? exPos : 0));
        }
        if (menuLabels.length < 6) {
          menuLabels.push(s((el.textContent || '').replace(/^\s+|\s+$/g, '')).slice(0, 22) + '.' + NAV_SFC);
        }
        mstep('menu_expand', {
          mf_level: (parentView === 'root') ? 2 : 3,
          mf_label: s((el.textContent || '').replace(/^\s+|\s+$/g, '')),
          mf_view: s(el.getAttribute('data-view-name') || '')
        });
        return;
      }

      /* -- back: snippets/glossy-drawer.liquid:492 (level 2 -> root, no
            data-back-to) and :518 (level 3, carries data-back-to). Handler
            :578-589, branch at :582-586. -- */
      if ((el = closest(t, '[data-glossy-menu-back]'))) {
        interactions++;
        var backTo = el.getAttribute('data-back-to');
        mstep('menu_back', {
          mf_level: backTo ? 3 : 2,
          mf_label: s(backTo || 'root')
        });
        return;
      }

      /* -- close: overlay :390, X button :394. The drawer cart anchor :397 also
            closes it (bound :592-594) but is NOT a close affordance we want to
            conflate with abandonment — it is handled as a link below. -- */
      if ((el = closest(t, '[data-glossy-drawer-close]'))) {
        if (!isOpen) { return; }
        isOpen = false;
        mstep('menu_close', {
          mf_abandoned: interactions === 0 ? 'true' : 'false',
          mf_dwell_ms: openedAt ? (new Date().getTime() - openedAt) : 0
        });
        return;
      }

      /* -- link click: three LIVE families inside [data-glossy-drawer] —
            a.glossy-drawer-menu-link :462/:504/:524, a.glossy-drawer-shortcut
            :435/:438/:441/:444, a.glossy-drawer-footer-link :481.
            a.glossy-drawer-secondary-link :472 does NOT render
            (secondary_menu is "" in config/settings_data.json:431).
            The :not([aria-controls="mini-cart"]) exclusion is MANDATORY — the
            drawer header cart anchor at :397 would otherwise inflate
            menu_link_click and deflate abandonment. Anchors are plain links with
            NO theme JS, and closeDrawer does NOT run when one is clicked, so the
            drawer close event is not a reliable session terminator. -- */
      /* -- design tiles: the drawer's merchandising row. Ahead of the generic
            link handler on purpose - a tile IS an a[href], and folding it into
            'menu_link_click' loses the only surface-attributed answer to "does
            the menu sell anything". select_item still fires alongside; that one
            is the catalogue view of the same click, not the menu view. -- */
      if ((el = closest(t, '[data-glossy-drawer] a.glossy-drawer-designs__tile'))) {
        interactions++;
        var dname = s(textOf(el, '.glossy-drawer-designs__name'));
        if (dname && menuDesigns.length < 6) { menuDesigns.push(dname); }
        /* the availability experiment's outcome, qualified by the dealt arm so
           the top-vs-bottom click rates separate server-side */
        var dsgRoot = D.querySelector('.glossy-drawer-view[data-view="root"]');
        var dsgA = dsgRoot ? (dsgRoot.getAttribute('data-mx-dsg') || '') : '';
        if (dsgA === 'top' || dsgA === 'bot') { push('mf_menu_step', { mf_step: 'dsgclick_' + dsgA }); }
        mstep('menu_design_click', {
          mf_label: dname,
          mf_to: s(el.getAttribute('href') || '')
        });
        return;
      }

      if ((el = closest(t, '[data-glossy-drawer] a[href]'))) {
        if (el.getAttribute('aria-controls') === 'mini-cart') { return; }
        /* Modifier / middle click does not navigate — do not count it as exit. */
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) { return; }
        interactions++;
        var cls = el.className || '';
        var family = 'other';
        if (cls.indexOf('glossy-drawer-menu-link') > -1) { family = 'menu'; }
        else if (cls.indexOf('glossy-drawer-shortcut') > -1) { family = 'shortcut'; }
        else if (cls.indexOf('glossy-drawer-footer-link') > -1) { family = 'footer'; }
        if (family === 'menu' && menuLabels.length < 6) {
          /* the server slugs menuitem at 28 chars BEFORE charset-stripping - the
             label must leave room or the origin suffix gets truncated into noise */
          menuLabels.push(s((el.textContent || '').replace(/^\s+|\s+$/g, '')).slice(0, 22) + '.' + NAV_SFC);
        }
        if (family === 'menu') {
          /* the order experiment's dimensions: main-vs-sub from the containing
             view, slot from menu-mix's data-mx-pos. Steps give the two curves,
             the named pair gives the item-by-position cube. */
          var mxView = el.closest ? el.closest('.glossy-drawer-view') : null;
          var mxMain = mxView && mxView.getAttribute('data-view') === 'root';
          var mxPos = parseInt(el.getAttribute('data-mx-pos') || '0', 10) || 0;
          push('mf_menu_step', { mf_step: mxMain ? 'click_main' : 'click_sub' });
          if (mxMain && mxPos) { push('mf_menu_step', { mf_step: 'click_p' + Math.min(mxPos, 15) }); }
          if (menuPos.length < 6) {
            menuPos.push(s((el.textContent || '').replace(/^\s+|\s+$/g, '')).slice(0, 18) +
              '.' + (mxMain ? 'M' : 'S') + (mxMain && mxPos ? mxPos : 0));
          }
        }
        mstep('menu_link_click', {
          mf_label: s((el.textContent || '').replace(/^\s+|\s+$/g, '')),
          mf_family: family,
          mf_to: s(el.getAttribute('href') || ''),
          mf_dwell_ms: openedAt ? (new Date().getTime() - openedAt) : 0
        });
        return;
      }
    }, false);

    /* Escape closes the drawer: snippets/glossy-drawer.liquid:598-602, guarded
       on .is-open at :599. (The glossy SEARCH panel has no Escape handler —
       do not assume symmetry.) */
    D.addEventListener('keydown', function (e) {
      if (!e.isTrusted) { return; }
      if (e.key !== 'Escape' && e.keyCode !== 27) { return; }
      if (!isOpen) { return; }
      isOpen = false;
      mstep('menu_close', {
        mf_abandoned: interactions === 0 ? 'true' : 'false',
        mf_dwell_ms: openedAt ? (new Date().getTime() - openedAt) : 0,
        mf_close_route: 'escape'
      });
    }, false);

    /* The drawer has its OWN search field (snippets/glossy-drawer.liquid:159 and
       the redesigned :487) - a different surface from the header search sheet that
       initSearch watches. Mixing them cannot answer "do people search FROM the
       menu", which is the question that decides whether the menu's job is
       navigation or search. One event per settled query, not per keystroke. */
    var qTimer = null;
    D.addEventListener('input', function (e) {
      if (!e.isTrusted) { return; }
      var f = closest(e.target, '.glossy-drawer-search input');
      if (!f) { return; }
      if (qTimer) { W.clearTimeout(qTimer); }
      qTimer = W.setTimeout(function () {
        var q = String(f.value || '').replace(/^\s+|\s+$/g, '');
        if (q.length < 2) { return; }
        if (throttled('menu_query', 1500)) { return; }
        interactions++;
        /* arm-gated like dsgclick: if the experiment is off, the outcome must
           stop with the exposures or the srch analysis reads orphan numerators */
        var srchRoot = D.querySelector('.glossy-drawer-view[data-view="root"]');
        if (srchRoot && srchRoot.getAttribute('data-mx-srch') === 'on') {
          push('mf_menu_step', { mf_step: 'srch_used' });
        }
        mstep('menu_search', { mf_q_len: q.length });
      }, 900);
    }, true);
  }

  /* ==========================================================================
     5. BOOT
     ------------------------------------------------------------------------
     Loaded with defer, so the DOM is parsed by the time this runs in every
     modern browser — but never assume it. Both modules are delegation-based and
     tolerate a missing DOM except for the #gpSticky lookup, so retry once on
     DOMContentLoaded if the element is not there yet.
     ========================================================================*/

  /* ═══════════════════════════════════════════════════════════════════════════
     MOBILFOX micro-conversions (2026-08-06)

     Everything below covers what Shopify's native Google & YouTube pixel CANNOT
     see: which card was clicked out of which list, which PDP option was chosen,
     and what happened inside the cart drawer. The native pixel keeps owning
     view_item, add_to_cart, begin_checkout and the rest - ga4NameAllowed() refuses
     those names for both sinks, so nothing here can double-count a conversion.

     All listeners are delegated from documentElement in the CAPTURE phase. That is
     not a style choice: the mini-cart is destroyed and re-rendered from the server
     on every cart:refresh (assets/theme.js:5891-5930), so anything bound to a node
     inside it is silently lost after the first cart change. Capture also runs before
     handlers that navigate or stopPropagation.
     ═══════════════════════════════════════════════════════════════════════════ */

  function handleFromHref(href) {
    var m = String(href || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  function textOf(node, sel) {
    if (!node) { return ''; }
    var el = sel ? node.querySelector(sel) : node;
    return el ? String(el.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }

  /* Which list did this card belong to? Ordered most specific first. */
  function listSurfaceOf(node) {
    if (closest(node, '.glossy-drawer-panel, .glossy-drawer-container')) { return 'menu_drawer'; }
    if (closest(node, '.glossy-search')) { return 'header_sheet'; }
    if (closest(node, '.pr-designs')) { return 'pdp_designs'; }
    if (closest(node, '.ajax-collection')) { return 'home_rail'; }
    if (closest(node, '.main-search, .search-results')) { return 'search_page'; }
    if (SURFACE === 'collection') { return 'collection'; }
    if (SURFACE === 'search') { return 'search_page'; }
    return SURFACE || 'other';
  }

  function positionIn(card) {
    var parent = card.parentElement;
    if (!parent) { return 0; }
    var kids = parent.children;
    for (var i = 0; i < kids.length; i++) { if (kids[i] === card) { return i + 1; } }
    return 0;
  }

  /* --- product card clicks, every surface ---------------------------------- */
  function initSelectItem() {
    D.documentElement.addEventListener('click', function (ev) {
      var card = closest(ev.target, 'a.dcard, a.pr-designs__tile, a.glossy-drawer-designs__tile');
      if (!card) { return; }
      var handle = handleFromHref(card.getAttribute('href'));
      if (!handle) { return; }
      /* a card click can bubble through two matching ancestors on some surfaces */
      if (throttled('sel:' + handle, 500)) { return; }
      push('mf_select_item', {
        mf_item_handle: s(handle),
        mf_item_name: s(textOf(card, '.dcard__mark') || textOf(card, '.pr-designs__name') ||
                        textOf(card, '.glossy-drawer-designs__name')),
        mf_item_pos: positionIn(card),
        mf_list_surface: s(listSurfaceOf(card))
      });
    }, true);
  }

  /* --- the rhode product page --------------------------------------------- */
  function initRhodePdp() {
    var root = D.querySelector('[data-pr]');
    if (!root) { return; }   /* not the rhode template - nothing to bind */

    /* Did the previous page's designs strip send them here? Consume the note:
       "landed" plus "added after landing" is the difference between the strip
       helping the decision and the strip merely walking people away. */
    var cameFromDesigns = false;
    try {
      var dsgRaw = W.sessionStorage.getItem('mf_dsg');
      if (dsgRaw) {
        W.sessionStorage.removeItem('mf_dsg');
        var dsg = JSON.parse(dsgRaw);
        if (dsg && dsg.t && (new Date()).getTime() - dsg.t < 45000) {
          cameFromDesigns = true;
          /* deferred: this runs during init, before initSessionBeacon() assigns
             beaconTap - a synchronous push here reaches GA4 but never the beacon */
          defer(function () {
            push('mf_pdp_step', { mf_step: 'designs_land', mf_option_value: s(dsg.n) });
          });
        }
      }
    } catch (eDsg) {}

    /* What the page chose for the visitor. Everything after is a departure from it,
       and "did they leave the default" is a different question from "what did they
       end up with". Read after the section has painted its first state. */
    var initialType = '', initialColor = '';
    W.setTimeout(function () {
      initialType = chipName(root.querySelector('.pr-type.is-active'));
      var sw0 = root.querySelector('.pr-sw.is-active, .pr-sw[aria-pressed="true"]');
      initialColor = sw0 ? s(sw0.getAttribute('data-color') || sw0.getAttribute('title') || '') : '';
    }, 1200);

    /* The type-chip name element contains the badge span too, so textContent says
       "Full-Shock Cel mai popular". The first child node is the clean name. */
    function chipName(node) {
      var el = node ? node.querySelector('.pr-type__name') : null;
      if (!el) { return ''; }
      var first = el.childNodes.length ? el.childNodes[0].textContent : el.textContent;
      return s(String(first || '').replace(/\s+/g, ' ').trim());
    }

    D.documentElement.addEventListener('click', function (ev) {
      /* The floating bar forwards its tap to the inline CTA with a synthetic
         .click() (product-rhode.liquid) - without this guard every float tap
         counted as TWO cta_clicks and inflated the funnel's second stage. */
      if (!ev.isTrusted) { return; }
      var t = ev.target;

      var up = closest(t, '[data-pr-up]');
      if (up) {
        push('mf_pdp_step', {
          mf_step: 'upsell_add',
          mf_variant_id: s(up.getAttribute('data-variant-id')),
          mf_up_name: s(textOf(up, '.pr-up__name'))
        });
        return;
      }

      var ms = closest(t, '[data-pr-magsafe-btn]');
      if (ms) {
        /* the page's own handler flips the state, so read it one tick later */
        defer(function () {
          var on = ms.getAttribute('aria-pressed') === 'true';
          push('mf_pdp_option_change', {
            mf_option: 'magsafe',
            mf_option_value: on ? 'on' : 'off',
            mf_magsafe: on ? 1 : 0
          });
        });
        return;
      }

      /* This listener is on the capture phase, so the section has not re-rendered
         yet and the currently-active chip is still the PREVIOUS choice. That is the
         only moment "from" exists - after the click it is gone. */
      var type = closest(t, '.pr-type');
      if (type) {
        var toType = chipName(type);
        var fromType = chipName(root.querySelector('.pr-type.is-active'));
        if (toType && toType !== fromType) {
          push('mf_pdp_option_change', {
            mf_option: 'type',
            mf_option_value: toType,
            mf_option_from: fromType,
            mf_from_default: fromType && fromType === initialType ? 'yes' : 'no'
          });
        }
        return;
      }

      var sw = closest(t, '.pr-sw');
      if (sw) {
        var toColor = s(sw.getAttribute('data-color') || sw.getAttribute('title') || '');
        var activeSw = root.querySelector('.pr-sw.is-active, .pr-sw[aria-pressed="true"]');
        var fromColor = activeSw ? s(activeSw.getAttribute('data-color') || activeSw.getAttribute('title') || '') : '';
        /* Only a real change. Re-clicking the current swatch is not a colour decision,
           and counting it would inflate the one number that says "they cared". */
        if (toColor && toColor !== fromColor) {
          push('mf_pdp_option_change', {
            mf_option: 'color',
            mf_option_value: toColor,
            mf_option_from: fromColor,
            mf_from_default: fromColor && fromColor === initialColor ? 'yes' : 'no'
          });
        }
        return;
      }

      var floatCta = closest(t, '[data-pr-float-cta]');
      var inlineCta = closest(t, '[data-pr-cta]');
      if (floatCta || inlineCta) {
        var btn = floatCta || inlineCta;
        push('mf_pdp_step', {
          mf_step: 'cta_click',
          mf_origin: floatCta ? 'float' : 'inline',
          mf_variant_id: s(btn.getAttribute('data-variant-id') || (btn.dataset && btn.dataset.variantId) || '')
        });
        if (cameFromDesigns) {
          /* they came here off the strip AND pressed add - the strip closed a sale */
          push('mf_pdp_step', { mf_step: 'designs_land_add' });
        }
        return;
      }

      var dtile = closest(t, '.pr-designs__tile');
      if (dtile) {
        push('mf_pdp_step', {
          mf_step: 'designs_click',
          mf_option_value: s(textOf(dtile, '.pr-designs__name'))
        });
        /* the landing pageview reads this back as designs_land */
        try {
          W.sessionStorage.setItem('mf_dsg', JSON.stringify({
            n: s(textOf(dtile, '.pr-designs__name')),
            t: (new Date()).getTime()
          }));
        } catch (eDsg2) {}
        return;
      }

      var acc = closest(t, '.pr-acc__head');
      if (acc) {
        push('mf_pdp_step', { mf_step: 'accordion_open', mf_option_value: s(textOf(acc)) });
      }
    }, true);

    /* device picker: a change here navigates to another product */
    var deviceSelect = root.querySelector('[data-pr-device]');
    if (deviceSelect) {
      deviceSelect.addEventListener('change', function () {
        push('mf_device_change', {
          mf_device_to: s(deviceSelect.value),
          mf_device_from: s(CFG.productHandle),
          mf_via: 'select'
        });
      }, true);
    }

    /* the floating bar becoming visible is a real funnel step, but only once */
    var floatBar = D.querySelector('[data-pr-float]');
    if (floatBar && W.MutationObserver) {
      new W.MutationObserver(function () {
        if (floatBar.classList.contains('is-visible') && once('float_impression')) {
          push('mf_pdp_step', { mf_step: 'float_impression' });
        }
      }).observe(floatBar, { attributes: true, attributeFilter: ['class'] });
    }

    /* the designs marquee sits below the fold - a click count without "how many
       even scrolled to it" reads as apathy when it is really invisibility */
    var designsStrip = root.querySelector('.pr-designs');
    if (designsStrip && W.IntersectionObserver) {
      var designsIo = new W.IntersectionObserver(function (entries) {
        for (var di = 0; di < entries.length; di++) {
          if (entries[di].isIntersecting && once('designs_view')) {
            push('mf_pdp_step', { mf_step: 'designs_view' });
            designsIo.disconnect();
            break;
          }
        }
      }, { threshold: 0.4 });
      designsIo.observe(designsStrip);
    }
  }

  /* --- the cart drawer ----------------------------------------------------- */
  function initCartDrawer() {
    D.documentElement.addEventListener('click', function (ev) {
      var t = ev.target;

      var prot = closest(t, '[data-cart-protector-add]');
      if (prot) {
        var cpuKind = s(textOf(closest(prot, '.cpu'), '.cpu__name'));
        push('mf_cart_step', {
          mf_step: 'protector_add',
          mf_variant_id: s(prot.getAttribute('data-variant-id')),
          mf_cpu_kind: cpuKind
        });
        /* Which protector, by name, on the first-party side too - the step counter
           alone could not say Nano vs Pro-Shield. Falls back to the hardcoded
           endpoint because the drawer exists on pages where no section published
           a beacon URL. */
        try {
          var pUrl = beaconTarget() || 'https://mf-beacon.vercel.app/api/case-add';
          if (cpuKind && W.navigator.sendBeacon) {
            W.navigator.sendBeacon(pUrl, new Blob([JSON.stringify({
              /* The drawer's own add. It is the one beacon that is NOT built by the
                 session sender, so the country field has to be repeated here - without
                 it this sender falls to the Origin net, and to Romania when even that
                 misses. Found by splitting `noc` per kind on the server. */
              kind: 'item_add', surface: 'cart', product: cpuKind, vp: viewportClass(),
              c: s(CFG.shop)
            })], { type: 'text/plain' }));
          }
        } catch (eP) {}
        return;
      }

      var checkout = closest(t, '[name="checkout"]');
      if (checkout) {
        push('mf_cart_step', { mf_step: 'checkout_click', mf_line_count: cartLineCount() });
        return;
      }

      var coupon = closest(t, '.discount-toggle-btn');
      if (coupon) {
        push('mf_cart_step', { mf_step: 'coupon_toggle' });
        return;
      }

      /* Removals and quantity changes are all /cart/update.js anchors in this theme
         (sections/mini-cart.liquid:972,980,993). The target quantity is in the href;
         the decrease anchor at quantity 1 already points at 0, so 'removed the line'
         is one condition, not a guess from CSS classes that differ per breakpoint. */
      var qa = closest(t, 'a[href*="/cart/update.js"]');
      if (qa) {
        var mQty = String(qa.getAttribute('href') || '').match(/updates\[[^\]]*\]=(\d+)/);
        if (mQty) {
          var target = parseInt(mQty[1], 10);
          if (target === 0) {
            push('mf_cart_step', { mf_step: 'remove_item', mf_line_count: cartLineCount() });
            /* WHAT left the cart: a third of adds get removed, and the type
               names the reason candidates. Classified from the line's own
               text; the old remove_item series stays untouched. */
            try {
              var line = closest(qa, '.line-item') || closest(qa, 'li') || closest(qa, '[class*="product-item"]');
              var txt = line ? String(line.textContent || '') : '';
              var rmKind = /pro.?shield|nano.?glass|folie|protector/i.test(txt) ? 'rm_prot'
                : /iphone|samsung|galaxy|huawei|xiaomi|oneplus/i.test(txt) ? 'rm_case' : 'rm_other';
              push('mf_cart_step', { mf_step: rmKind });
              if (/Reducere folie/i.test(txt)) { push('mf_cart_step', { mf_step: 'rm_promo' }); }
            } catch (eR) {}
          } else {
            var qsel = closest(qa, '.quantity-selector');
            var qinp = qsel ? qsel.querySelector('.quantity-selector__input') : null;
            var cur = qinp ? parseInt(qinp.value, 10) : NaN;
            push('mf_cart_step', {
              mf_step: !isFinite(cur) ? 'qty_change' : (target < cur ? 'qty_decrease' : 'qty_increase')
            });
          }
        }
        return;
      }
    }, true);

    /* Coupon reality, in three separate numbers: arrived with a code already applied
       (the dCart toggle button only EXISTS when codes are present -
       snippets/dcart-override.liquid:397,437), opened the coupon box, and actually
       applied one. The last comes from dCart's own event bus, because a click on
       "apply" says nothing about whether the code was valid. The bus arrives async
       from an app embed, so subscription retries rather than assuming boot order. */
    var couponPresentSent = false;
    function checkCouponPresent() {
      if (couponPresentSent) { return; }
      if (D.querySelector('.discount-toggle-btn')) {
        couponPresentSent = true;
        push('mf_cart_step', { mf_step: 'coupon_present' });
      }
    }

    var dcartTries = 0;
    (function hookDcart() {
      try {
        if (W.dcartAPI && W.dcartAPI.eventBus && W.dcartAPI.Events &&
            W.dcartAPI.Events.Discount && W.dcartAPI.Events.Discount.Apply) {
          W.dcartAPI.eventBus.subscribe(W.dcartAPI.Events.Discount.Apply, function () {
            push('mf_cart_step', { mf_step: 'coupon_apply' });
          });
          return;
        }
      } catch (eD) {}
      if (++dcartTries < 6) { W.setTimeout(hookDcart, 1500); }
    })();

    /* drawer opened: the element survives the re-render, its attribute does not */
    var drawer = D.querySelector('cart-drawer');
    if (drawer && W.MutationObserver) {
      new W.MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          if (records[i].attributeName !== 'open') { continue; }
          if (!drawer.hasAttribute('open')) { continue; }
          if (throttled('drawer_open', 1200)) { return; }
          push('mf_cart_step', { mf_step: 'drawer_open', mf_line_count: cartLineCount() });
          /* the dCart widget renders async after the drawer - look twice */
          W.setTimeout(checkCouponPresent, 600);
          W.setTimeout(checkCouponPresent, 2500);
        }
      }).observe(drawer, { attributes: true, attributeFilter: ['open'] });
    }
  }

  function cartLineCount() {
    try {
      if (W.mfCart && typeof W.mfCart.count === 'function') { return W.mfCart.count(); }
    } catch (e) {}
    return -1;
  }

  /* --- search -------------------------------------------------------------- */
  function initSearch() {
    D.documentElement.addEventListener('click', function (ev) {
      var chip = closest(ev.target, '.glossy-search__chip');
      if (chip) {
        push('mf_search_step', { mf_step: 'chip_click', mf_option_value: s(textOf(chip)) });
        return;
      }
      var studio = closest(ev.target, '[data-studio-link]');
      if (studio) {
        push('mf_search_step', { mf_step: 'studio_click' });
        return;
      }
      var opener = closest(ev.target, '[data-glossy-search-open], [aria-controls="glossy-search"]');
      if (opener && !throttled('sheet_open', 800)) {
        push('mf_search_step', { mf_step: 'sheet_open' });
      }
    }, true);

    /* one event per settled query, not per keystroke */
    var field = D.querySelector('.glossy-search__field input, input[name="q"]');
    if (field) {
      var timer = null;
      field.addEventListener('input', function () {
        if (timer) { W.clearTimeout(timer); }
        timer = W.setTimeout(function () {
          var q = String(field.value || '').trim();
          if (q.length < 2) { return; }
          push('mf_search_step', { mf_step: 'query', mf_q_len: q.length });
          /* Query CATEGORY, never the text: the routing decision needs to know
             how much of search is device-shaped. 'device' = carries a brand
             token; 'model' = bare model shorthand ("17 pro", "s24 ultra") -
             device-intent without a brand word; everything else is 'other'
             (design names, materials, misc). */
          var qcat = /(iphone|samsung|galaxy|huawei|xiaomi|redmi|oneplus|pixel|honor|oppo|realme|nothing)/i.test(q) ? 'qcat_device'
            : /^s?\d{1,2}\s*(pro|max|plus|ultra|air|mini|fe)?\s*(max|plus)?$/i.test(q) ? 'qcat_model'
            : 'qcat_other';
          push('mf_search_step', { mf_step: qcat });
        }, 900);
      }, true);
    }
  }

  /* Public entry point for section code that lives outside this file - the swipe
     deck in sections/mf-tinder.liquid is the first caller. Same guards as every
     internal push: the mf_ prefix is enforced, the native eleven are refused, and
     nothing is delivered on a dev theme unless preview mode was opted into. */
  /* --- how far down the page people actually get ---------------------------
     GA4's Enhanced Measurement fires a single `scroll` at 90%, which cannot answer
     "where do people stop". Milestones at 25/50/75/100 give the distribution, and
     because mf_viewport rides on every event (see push), the mobile and desktop
     answers separate without a second instrument.

     Deliberately NOT named `scroll`: that is Enhanced Measurement's own event name
     and reusing it would blend two different definitions in one report.

     One event per milestone per pageview. rAF-gated, passive listener - a scroll
     handler that does work on every frame is the classic way to make a page feel
     broken on a mid-range Android. */
  function initScrollDepth() {
    var MARKS = [25, 50, 75, 100];
    var seen = {}, raf = 0, best = 0;

    function depth() {
      var d = D.documentElement, b = D.body;
      var h = Math.max(d.scrollHeight, b ? b.scrollHeight : 0);
      var vh = W.innerHeight || d.clientHeight || 0;
      var scrollable = h - vh;
      if (scrollable <= 0) { return 100; }   /* page shorter than the viewport */
      var y = W.pageYOffset || d.scrollTop || 0;
      return Math.max(0, Math.min(100, Math.round((y / scrollable) * 100)));
    }

    function check() {
      raf = 0;
      var pct = depth();
      if (pct <= best) { return; }
      best = pct;
      scrollBest = pct;
      for (var i = 0; i < MARKS.length; i++) {
        var m = MARKS[i];
        if (pct >= m && !seen[m]) {
          seen[m] = 1;
          push('mf_scroll_depth', { mf_depth: String(m) });
        }
      }
    }

    function onScroll() { if (!raf) { raf = W.requestAnimationFrame(check); } }

    W.addEventListener('scroll', onScroll, { passive: true });
    W.addEventListener('resize', onScroll, { passive: true });
    /* a page that fits the viewport is 100% seen without a single scroll event */
    check();
  }

  /* --- first-party session summary ----------------------------------------
     One request per pageview, not per event. GA4 already carries every step; this
     is the copy an ad blocker cannot remove, and the copy whose shape we control.

     Sending each event separately would be ~10 requests per session, which at this
     store's traffic is tens of thousands of writes a day - far past what a hobby
     store tier absorbs, and it degrades silently once the quota is gone. A summary
     answers the same questions (how far down, which steps, which case) for a tenth
     of the cost.

     Sent on pagehide, with visibilitychange as the fallback iOS actually fires.
     sendBeacon survives unload; fetch does not. */
  function beaconTarget() {
    /* config/settings_schema.json is merchant-owned, so there is no theme setting to
       read. The section that already has the URL publishes it on window instead, and
       it is resolved at send time - the section's inline script may well run after
       this module booted. */
    return CFG.beaconUrl || W.__mfBeacon || '';
  }

  /* --- how far into the gallery people actually go -------------------------
     A click counter cannot answer this: the stage is a scroll-snap strip
     (sections/product-rhode.liquid:1519), so most movement is a swipe that fires
     no event of its own. An IntersectionObserver rooted on the stage reports what
     genuinely came into view, swipe and thumbnail alike.

     The position is counted among the slides visible AT THAT MOMENT, not the
     authored data-pr-media index: choosing a colour hides the other colours' shots
     (product-rhode.liquid filterMediaByColor), so a fixed index would report
     "image 5" for what the visitor is looking at as their second one.

     Position 1 is recorded rather than skipped - it is the denominator every later
     position is read against. */
  function initGallery() {
    var stage = D.querySelector('[data-pr-stage]');
    if (!stage || !W.IntersectionObserver) { return; }

    var slides = stage.querySelectorAll('.pr-media__slide');
    if (!slides.length) { return; }

    /* Dedupe by SLIDE IDENTITY, never by position. Choosing a colour re-filters the
       strip, so position 2 before the switch and position 2 after it are different
       photographs. Keying on position made every already-burned ordinal silent, and
       a visitor comparing three colours - twelve images seen - reported three. */
    var distinct = 0;
    var flush = null;

    function report() {
      flush = null;
      /* One event carrying the reach, not one per slide. Twelve slides used to mean
         twelve GA4 requests per pageview; the distribution is identical from a
         single number and the beacon carries it either way. */
      push('mf_pdp_step', { mf_step: 'gallery_view', mf_gallery_index: galleryMax });
    }

    var io = new W.IntersectionObserver(function (entries) {
      var grew = false;
      for (var i = 0; i < entries.length; i++) {
        var el = entries[i].target;
        if (!entries[i].isIntersecting) { continue; }
        if (el.getAttribute('data-mf-seen') === '1') { continue; }
        el.setAttribute('data-mf-seen', '1');
        distinct++;
        if (distinct > galleryMax && galleryMax < 12) { galleryMax = distinct; grew = true; }
      }
      if (!grew) { return; }
      if (flush) { W.clearTimeout(flush); }
      flush = W.setTimeout(report, 2500);
    }, { root: stage, threshold: 0.6 });

    for (var j = 0; j < slides.length; j++) { io.observe(slides[j]); }

    /* A visitor who leaves mid-swipe still had the reach they had. */
    D.addEventListener('visibilitychange', function () {
      if (D.visibilityState === 'hidden' && flush) { W.clearTimeout(flush); report(); }
    }, false);
  }

  /* --- which parts of the page people actually reach -----------------------
     A percentage cannot answer "did they see the drop test". The PDP is 8.3 screens
     tall and the blocks are wildly uneven - the buy rail is 80px, the facts block is
     1122px - so 50% depth lands somewhere different on every product.

     Named blocks answer it directly. Order is resolved from the DOM at runtime, NOT
     from this list: measured live, the CTA sits at 1636px while the description sits
     at 686px, so any hardcoded order would have been wrong on the first product. The
     rail also reflows between mobile and desktop.

     Blocks absent from a given product simply do not report - a product with no drop
     test block should not show a 0% drop-test row, it should show no row. */
  var PAGE_BLOCKS = [
    { k: 'gallery',     s: '[data-pr-media-root]' },
    { k: 'buy',         s: '.pr-cta-wrap, [data-pr-cta]' },
    { k: 'desc',        s: '[data-pr-desc]' },
    { k: 'routine',     s: '.pr-routine' },
    { k: 'designs',     s: '.pr-designs' },
    { k: 'faq',         s: '.pr-acc' },
    { k: 'droptest',    s: '.prx-dt' },
    { k: 'facts',       s: '.prx-split' },
    { k: 'video',       s: '.prx-full' },
    { k: 'social',      s: '.shopify-section--social-slider, [id*="social_rail"]' },
    { k: 'recommended', s: '.shopify-section--ajax-collection, [id*="ajax_rail"]' },
    { k: 'footer',      s: '#shopify-section-footer' }
  ];

  function initBlockDepth() {
    if (!D.querySelector('[data-pr]') || !W.IntersectionObserver) { return; }

    var found = [];
    for (var i = 0; i < PAGE_BLOCKS.length; i++) {
      var el = D.querySelector(PAGE_BLOCKS[i].s);
      if (el) { found.push({ k: PAGE_BLOCKS[i].k, el: el }); }
    }
    if (!found.length) { return; }

    /* Document order, measured - see the note above. */
    found.sort(function (a, b) {
      var rel = a.el.compareDocumentPosition(b.el);
      if (rel & 4) { return -1; }   /* a precedes b */
      if (rel & 2) { return 1; }
      return 0;
    });

    var index = {};
    for (var j = 0; j < found.length; j++) { index[found[j].k] = j + 1; }

    var io = new W.IntersectionObserver(function (entries) {
      for (var e = 0; e < entries.length; e++) {
        if (!entries[e].isIntersecting) { continue; }
        var key = entries[e].target.getAttribute('data-mf-block');
        if (!key) { continue; }
        io.unobserve(entries[e].target);   /* once seen, stop paying for it */
        if (blocksSeen.indexOf(key) > -1) { continue; }
        blocksSeen.push(key);
        push('mf_pdp_step', {
          mf_step: 'block_view',
          mf_block: key,
          mf_block_index: index[key] || 0
        });
      }
    }, { threshold: 0, rootMargin: '0px 0px -15% 0px' });

    for (var n = 0; n < found.length; n++) {
      found[n].el.setAttribute('data-mf-block', found[n].k);
      io.observe(found[n].el);
    }
  }

  function initSessionBeacon() {
    if (!W.navigator || !W.navigator.sendBeacon) { return; }

    /* One send per pageview loses everyone who backgrounds the tab and comes back
       to buy - on mobile that is not an edge case, it is the pattern. So the send
       re-arms when the page becomes visible again, and the follow-up carries ONLY
       what is new: no sessions, no viewport, no offer set. Re-sending those would
       inflate the denominator, which is worse than the gap it fixes.

       Capped at three sends: a page that flips visible/hidden all afternoon should
       not be able to talk to the store all afternoon. */
    var sends = 0;
    var sentSteps = {};
    var sentGallery = 0;
    var sentScroll = -1;
    var sentCase = '';
    var sentBlocks = {};
    var sentGalAdd = 0;   /* deepest gallery position already credited to an adder */
    var sentBlocksAdd = {};
    var sentStepsAdd = {};
    var sentStepsChk = {};
    var sentScrollAdd = -1;
    var sentMenuL = 0;    /* how many menu labels / designs already went out - a
                             re-send would double-count them server-side */
    var sentMenuD = 0;
    var sentMenuP = 0;
    var sentDefChk = false;  /* checkout credited to the dealt default, once */
    var steps = {};

    /* ═══ SESSION FUNNEL (2026-10-16) ══════════════════════════════════════════
       WHY. Every other counter in this beacon is per PAGEVIEW: 'sessions' are
       main-PDP pageviews, and case_add / cart:drawer_open / cart:checkout_click are
       once per pageview. Under 1+1 and 2+2 one buyer opens several product pages
       and adds on each, so "checkout per adding pageview" falls while buyers do not
       (RO 0.68 -> 0.52 was entirely that), and stores running different offers
       cannot be compared at all. This block reports ONE funnel per browser session,
       with identical semantics on all six stores.

       SESSION = the tab's sessionStorage lifetime - the same notion as mf_entry.
       Known limit of that notion: "Duplicate tab", or a window.open that keeps its
       opener, COPIES sessionStorage, and both copies then carry their own add /
       open / chk against one 's'. Rare (links open with noopener by default) and
       shared with mf_entry; nothing per tab can tell the two copies apart.

       STORAGE  sessionStorage 'mf_ses1' = { v:1, f:{mark:1}, p:{mark:1}, n:count }
         f  marks a beacon has already carried (sendBeacon returned true)
         p  marks noticed but not carried yet. Persisted so that a pageview whose
            beacon never went out (a refused sendBeacon, a page that died without
            pagehide) hands them to the next pageview instead of losing them -
            's' is retried on every pageview anyway, so losing an 'add' or a 'chk'
            there would bias every rate downwards. Not hypothetical: measured
            2026-10-16 in WebKit (iPhone profile), a fresh visitor's FIRST navigation
            bounces through shop.app/accounts/sur and the landing page then fires no
            pagehide and no visibilitychange at all - its whole beacon is lost, and
            only p brings a landing-page add over to the next pageview.
         n  the last cart ITEM count seen, -1 = none seen yet

       MARKS - each at most once per session, always sent in this order:
         s     the session exists. Every pageview tries it; only the first sends.
         pdp   viewed any product page (CFG.pageType 'product', any template)
         cart  the cart held >= 1 item at some moment of the session
         add   an add made in THIS tab: case_add, feed:add or cart:protector_add
               reached beaconTap; OR the cart item count, read after a cart event on
               this page, rose above the stored n; OR a classic (non-AJAX) form post
               to /cart/add left this page.
               NOT the count the server rendered at page load: the cart is
               browser-wide (a cookie) while the session is per tab, so a rise seen
               at load may be ANOTHER tab's add - one physical add would then count
               as two adding sessions, one of them maybe without a product page
               (review C2, reproduced live). At load the count only takes 'cart' and
               moves n.
         open  opened the cart drawer (cart:drawer_open)
         chk   clicked the drawer's checkout button (cart:checkout_click)

       WIRE. body.ses = [marks], riding on whichever session / session_more beacon
       goes out next; fresh = (this page's marks + stored p) minus stored f, read
       from storage at send time, so a bfcache-restored page with a stale heap
       merges instead of sending twice. Merged into f only AFTER sendBeacon
       returned true. NEVER in steps, steps_add / steps_chk or pri(): these are
       session facts, and a pageview join over them would re-create the very
       artefact this block removes (the same rule as HU's mnx: flags, review C8).
       A beacon with no fresh mark is byte-identical to one sent before this block.
       PAST THE 3-SEND CAP (review C1): the pageview's own fields stay capped, but
       fresh marks still leave, alone, on a minimal session_more (sesCapped). The
       next document after the add and the checkout click is the checkout, where
       this file does not run - a buyer who had backgrounded that product page
       three times would otherwise never send add / cart / open / chk, a loss that
       falls on exactly the converters. Bounded by construction: a mark is carried
       once per session, so at most six such requests per session.

       OFF. Storage is proven by a write + read-back at init. If sessionStorage is
       missing, throws, or does not read back, this block sends NOTHING for the
       page. A per-pageview fallback would be the artefact again under a new name.

       CART EVENTS are read, not counted: one read of the item count (mfCart, kept
       current by snippets/js-variables.liquid) ~400 ms after each cart:refresh /
       cart:updated / variant:added on the documentElement. One add fans out into
       several events; here that only repeats an idempotent read whose result is a
       once-per-session mark, which is why the header's "never bind to cart
       events" rule (a rule about COUNTING them) does not bite here. Residual: a
       cart event on this page right after ANOTHER tab added (with no load of this
       page in between) still reads that add as a rise - far rarer than every
       page load, which is what the load-time rule above removes.
       ══════════════════════════════════════════════════════════════════════════ */
    var SES_KEY = 'mf_ses1';
    var SES_ORDER = ['s', 'pdp', 'cart', 'add', 'open', 'chk'];
    /* beaconTap key -> mark */
    var SES_TAP = {
      'case_add': 'add', 'feed:add': 'add', 'cart:protector_add': 'add',
      'cart:drawer_open': 'open', 'cart:checkout_click': 'chk'
    };
    var sesOn = false;   /* storage proven at init - otherwise nothing below sends */
    var sesPend = {};    /* page memory: the marks this pageview noticed */

    /* null = storage failed right now (callers then do nothing). A value this
       version did not write reads as a new session. */
    function sesRead() {
      var raw;
      try { raw = W.sessionStorage.getItem(SES_KEY); } catch (e) { return null; }
      try {
        var r = JSON.parse(raw || 'null');
        if (r && r.v === 1 && r.f && typeof r.f === 'object') {
          return {
            v: 1,
            f: r.f,
            p: (r.p && typeof r.p === 'object') ? r.p : {},
            n: (typeof r.n === 'number' && r.n >= 0) ? r.n : -1
          };
        }
      } catch (e2) {}
      return { v: 1, f: {}, p: {}, n: -1 };
    }
    function sesWrite(st) {
      try { W.sessionStorage.setItem(SES_KEY, JSON.stringify(st)); } catch (e) {}
    }
    function sesNote(st, m) {
      sesPend[m] = 1;
      if (!st.f[m]) { st.p[m] = 1; }
    }
    function sesMark(m) {
      if (!sesOn) { return; }
      sesPend[m] = 1;
      var st = sesRead();
      if (st && !st.f[m] && !st.p[m]) { sesNote(st, m); sesWrite(st); }
    }
    /* c = a cart ITEM count (-1 / non-number = unknown, ignored). how:
         'event' - read after a cart event on this page: a rise above n is an add
         'load'  - the count the server rendered for this pageview: 'cart' and n
                   only, never an add (see MARKS: the cart is browser-wide)
         'bf'    - the same on a back/forward navigation, which may be served from
                   the HTTP cache (this store sends max-age=0, not no-store) with a
                   stale count: 'cart' only, n untouched */
    function sesCount(c, how) {
      if (!sesOn || typeof c !== 'number' || !isFinite(c) || c < 0) { return; }
      var st = sesRead();
      if (!st) { return; }
      if (c >= 1) { sesNote(st, 'cart'); }
      if (how === 'event' && st.n >= 0 && c > st.n) { sesNote(st, 'add'); }
      if (how !== 'bf') { st.n = c; }
      sesWrite(st);
    }
    function sesTap(key) {
      if (sesOn && Object.prototype.hasOwnProperty.call(SES_TAP, key)) { sesMark(SES_TAP[key]); }
    }
    /* fire(): the marks this beacon should carry, in SES_ORDER */
    function sesTake() {
      if (!sesOn) { return []; }
      var st = sesRead();
      if (!st) { return []; }
      var out = [];
      for (var i = 0; i < SES_ORDER.length; i++) {
        var m = SES_ORDER[i];
        if ((sesPend[m] || st.p[m]) && !st.f[m]) { out.push(m); }
      }
      return out;
    }
    /* fire(), after sendBeacon returned true: carried = done for the session */
    function sesDone(list) {
      var st = sesRead();
      if (!st) { return; }
      for (var i = 0; i < list.length; i++) { st.f[list[i]] = 1; delete st.p[list[i]]; }
      sesWrite(st);
    }
    /* fire() at its 3-send cap (see WIRE): the fresh marks alone. case-add books
       nothing but ses:* from this body - no steps, blocks, gallery or menu rows. */
    function sesCapped(url) {
      var list = sesTake();
      if (!list.length) { return; }
      try {
        if (!W.navigator.sendBeacon(url, new Blob([JSON.stringify({
          kind: 'session_more', c: s(CFG.shop), vp: viewportClass(), steps: [], ses: list
        })], { type: 'text/plain' }))) { return; }
      } catch (e) { return; }
      sesDone(list);
    }
    function sesBackForward() {
      try {
        var pf = W.performance;
        var nav = (pf && pf.getEntriesByType) ? pf.getEntriesByType('navigation')[0] : null;
        if (nav && nav.type) { return nav.type === 'back_forward'; }
        return !!(pf && pf.navigation && pf.navigation.type === 2);
      } catch (e) { return false; }
    }
    (function sesInit() {
      try {
        var store = W.sessionStorage;
        if (!store) { return; }
        var st = sesRead();
        if (!st) { return; }
        var txt = JSON.stringify(st);
        store.setItem(SES_KEY, txt);
        sesOn = store.getItem(SES_KEY) === txt;
      } catch (e) { sesOn = false; }
      if (!sesOn) { return; }

      sesMark('s');
      if (s(CFG.pageType) === 'product') { sesMark('pdp'); }

      /* the cart as the server rendered it for this pageview */
      var c0 = -1;
      try {
        var tv = W.themeVariables && W.themeVariables.settings;
        if (tv && typeof tv.cartCount === 'number') { c0 = tv.cartCount; }
      } catch (e3) {}
      if (c0 < 0) { c0 = cartLineCount(); }
      sesCount(c0, sesBackForward() ? 'bf' : 'load');

      /* ...and as it changes on this pageview. Capture phase: the read must not
         depend on whether the dispatcher set bubbles. */
      var CART_EVENTS = ['cart:refresh', 'cart:updated', 'variant:added'];
      for (var ce = 0; ce < CART_EVENTS.length; ce++) {
        DE.addEventListener(CART_EVENTS[ce], function () {
          W.setTimeout(function () { sesCount(cartLineCount(), 'event'); }, 400);
        }, true);
      }

      /* A classic form post to /cart/add navigates away before any cart event, and
         the next page's load-time count no longer credits it - so the submit is the
         add. Bubble phase, and only when nothing called preventDefault: a submit an
         AJAX handler took over ends in a cart event instead, whose count read
         credits the add only if it really landed. */
      DE.addEventListener('submit', function (ev) {
        try {
          var fm = ev && ev.target;
          if (ev.defaultPrevented || !fm || !fm.getAttribute) { return; }
          if (String(fm.getAttribute('action') || '').indexOf('/cart/add') > -1) { sesMark('add'); }
        } catch (e4) {}
      }, false);
    })();
    /* ═══ end SESSION FUNNEL ═══════════════════════════════════════════════════ */

    /* every mf_ event contributes its own step name, so this needs no per-feature
       wiring and picks up whatever the funnel grows next */
    beaconTap = function (name, params) {
      /* mf_diag is a health ping that fires on every pageview - in a funnel it would
         sit at 100% and make every real stage look like a drop. */
      if (name === 'mf_diag') { return; }
      var key = name.replace(/^mf_/, '');
      if (name === 'mf_nav_step') {
        /* the listing/navigation layer sends its surface prefix itself
           (home:/plp:/srch:/entry:) - the step travels as-is */
        key = s(params && params.mf_step);
      } else if (name === 'mf_pdp_step' || name === 'mf_cart_step' ||
          name === 'mf_menu_step' || name === 'mf_search_step' ||
          name === 'mf_promo_step') {
        /* Without the sub-step the whole menu arrives as one field called
           'menu_step' and every question about it - opened, searched, clicked
           what - collapses into a single number. */
        key = key.replace(/_step$/, '') + ':' + s(params && params.mf_step);
      } else if (name === 'mf_pdp_option_change') {
        key = 'option:' + s(params && params.mf_option);
      } else if (name === 'mf_scroll_depth') {
        return; /* depth travels as a number, not as four separate steps */
      }
      /* Same reasoning as scroll: gallery depth travels as one number, or it eats
         twelve of the twenty-four step slots and reads as twelve funnel stages. */
      if (key === 'pdp:gallery_view' || key === 'pdp:block_view') { return; }
      sesTap(key);   /* SESSION FUNNEL: add / open / chk marks - never a step */
      steps[key] = 1;
    };

    function fire() {
      var url = beaconTarget();
      if (!url) { return; }
      if (sends >= 3) { sesCapped(url); return; }   /* SESSION FUNNEL: past the cap, fresh marks alone */

      var fresh = [];
      var all = Object.keys(steps);
      /* the exit mark is by construction the LAST key inserted (pagehide) - on a
         busy pageview the 24-cap would starve exactly it, so it goes first */
      /* 2026-10-13 (PL popup A/B/C test): pgs: (the popup arm's session key) and pgv: (its once-per-visitor key),
         both from sections/mf-popup-game.liquid, ride with the exit mark for the same reason (as on RO and HU). The
         writer renders only while the test runs, so outside it no such key exists to move and the order is as before. */
      function pri(k) { return (k.indexOf(':left_') > 0 || /^(pgs|pgv):/.test(k)) ? 1 : 0; }
      all.sort(function (a, b) {
        return pri(b) - pri(a);
      });
      for (var i = 0; i < all.length && fresh.length < 32; i++) {
        if (!sentSteps[all[i]]) { fresh.push(all[i]); }
      }

      var freshBlocks = [];
      for (var bi = 0; bi < blocksSeen.length && freshBlocks.length < 16; bi++) {
        if (!sentBlocks[blocksSeen[bi]]) { freshBlocks.push(blocksSeen[bi]); }
      }

      var first = sends === 0;
      var addSeen = !!steps.case_add || !!steps['feed:add'];  /* the feed's add is an add */
      var chkSeen = !!steps['cart:checkout_click'];

      /* The joins: which of everything seen belongs to a visitor who ALSO added
         (or went on to checkout). Credited fresh-only, exactly like the base
         counts, so a top-up extends the credit instead of repeating it. */
      var addBlocks = [];
      var addSteps = [];
      var chkSteps = [];
      if (addSeen) {
        for (var abi = 0; abi < blocksSeen.length && addBlocks.length < 16; abi++) {
          if (!sentBlocksAdd[blocksSeen[abi]]) { addBlocks.push(blocksSeen[abi]); }
        }
        for (var asi = 0; asi < all.length && addSteps.length < 24; asi++) {
          if (!sentStepsAdd[all[asi]]) { addSteps.push(all[asi]); }
        }
      }
      if (chkSeen) {
        for (var csi = 0; csi < all.length && chkSteps.length < 24; csi++) {
          if (!sentStepsChk[all[csi]]) { chkSteps.push(all[csi]); }
        }
      }

      /* SESSION FUNNEL: the marks this session has not carried yet (storage re-read now) */
      var sesFresh = sesTake();

      /* Nothing new to say - do not spend a request saying it. */
      if (!first && !fresh.length && !freshBlocks.length && galleryMax <= sentGallery &&
          scrollBest <= sentScroll && (!sessionCaseType || sessionCaseType === sentCase) &&
          !(addSeen && galleryMax > sentGalAdd) &&
          !(addSeen && scrollBest > sentScrollAdd) &&
          !addBlocks.length && !addSteps.length && !chkSteps.length &&
          !(chkSeen && W.__mfDefault && !sentDefChk) &&
          menuLabels.length <= sentMenuL && menuDesigns.length <= sentMenuD &&
          menuPos.length <= sentMenuP &&
          !sesFresh.length) { return; }

      var body = {
        kind: first ? 'session' : 'session_more',
        /* The server maps this to a country namespace (lib/countries.js). Sent as
           the permanent myshopify domain and mapped there, never as a literal
           country code here: this file is byte-shared across three themes. */
        c: s(CFG.shop),
        vp: viewportClass(),
        steps: fresh,
        /* Gallery reach is written cumulatively server-side, so a follow-up names
           the range it is adding rather than the total it has reached. */
        gallery_from: sentGallery,
        gallery: galleryMax
      };
      if (first) {
        body.offered = W.__mfOffered || '';
        body.default_type = s(W.__mfDefault || '');
        body.template = s(CFG.templateName);
        body.template_suffix = s(CFG.templateSuffix);
        body.product = s(CFG.productHandle);
      }
      /* Scroll and case type are exactly what changes AFTER the first send - the
         visitor this re-arm exists for is the one who comes back and goes deeper.
         Sent whenever they advance; the server takes the max for scroll and
         last-write for the case, so neither can double-count. */
      if (scrollBest > sentScroll) {
        body.scroll = scrollBest;
        /* The previously reported depth, so the server can move this pageview from
           its old bucket to the new one instead of counting it twice. */
        if (!first && sentScroll >= 0) { body.scroll_from = sentScroll; }
      }
      if (sessionCaseType && sessionCaseType !== sentCase) {
        body.case_type = sessionCaseType;
        if (!first && sentCase) { body.case_from = sentCase; }
      }
      body.blocks = freshBlocks;
      /* The join the report cannot make on its own: which gallery depths belong to
         a visitor who ALSO added to cart. Credited as a range so a later top-up
         extends it instead of re-counting it. */
      if (addSeen && galleryMax > sentGalAdd) {
        body.gal_add_from = sentGalAdd;
        body.gal_add_to = galleryMax;
      }
      if (addBlocks.length) { body.blocks_add = addBlocks; }
      if (addSteps.length) { body.steps_add = addSteps; }
      if (chkSteps.length) { body.steps_chk = chkSteps; }
      if (addSeen && scrollBest > sentScrollAdd) {
        body.scroll_add = scrollBest;
        if (sentScrollAdd >= 0) { body.scroll_add_from = sentScrollAdd; }
      }
      /* The experiment's checkout join: this pageview was dealt a default AND
         reached the checkout button. The steps map never clears, so a checkout
         from an earlier send still counts; the flag keeps it to one credit. */
      if (chkSeen && W.__mfDefault && !sentDefChk) {
        body.default_chk = s(W.__mfDefault);
      }
      /* Fresh-only, like everything else: the previous full-list re-send would
         have counted the same menu row once per beacon. */
      body.menu_labels = menuLabels.slice(sentMenuL, sentMenuL + 6);
      body.menu_designs = menuDesigns.slice(sentMenuD, sentMenuD + 6);
      body.menu_pos = menuPos.slice(sentMenuP, sentMenuP + 6);
      /* SESSION FUNNEL: absent when nothing is fresh, so such a beacon is unchanged */
      if (sesFresh.length) { body.ses = sesFresh; }

      try {
        if (!W.navigator.sendBeacon(url, new Blob([JSON.stringify(body)], { type: 'text/plain' }))) { return; }
      } catch (e) { return; }

      sends++;
      for (var j = 0; j < fresh.length; j++) { sentSteps[fresh[j]] = 1; }
      if (galleryMax > sentGallery) { sentGallery = galleryMax; }
      if (scrollBest > sentScroll) { sentScroll = scrollBest; }
      if (sessionCaseType) { sentCase = sessionCaseType; }
      for (var bj = 0; bj < freshBlocks.length; bj++) { sentBlocks[freshBlocks[bj]] = 1; }
      if (addSeen && galleryMax > sentGalAdd) { sentGalAdd = galleryMax; }
      for (var aj = 0; aj < addBlocks.length; aj++) { sentBlocksAdd[addBlocks[aj]] = 1; }
      for (var ak = 0; ak < addSteps.length; ak++) { sentStepsAdd[addSteps[ak]] = 1; }
      for (var al = 0; al < chkSteps.length; al++) { sentStepsChk[chkSteps[al]] = 1; }
      if (addSeen && scrollBest > sentScrollAdd) { sentScrollAdd = scrollBest; }
      if (body.default_chk) { sentDefChk = true; }
      sentMenuL = Math.min(menuLabels.length, sentMenuL + 6);
      sentMenuD = Math.min(menuDesigns.length, sentMenuD + 6);
      sentMenuP = Math.min(menuPos.length, sentMenuP + 6);
      /* menu labels are a set server-side, so re-sending them cannot double-count */
      if (sesFresh.length) { sesDone(sesFresh); }   /* SESSION FUNNEL: carried, so done */
    }

    W.addEventListener('pagehide', fire);
    D.addEventListener('visibilitychange', function () {
      if (D.visibilityState === 'hidden') { fire(); }
    });
  }

  W.mfTrackPush = function (name, params) {
    try {
      if (!MF_NAME_RE.test(String(name))) { diag('bad_public_name', String(name)); return; }
      push(String(name), params || {});
    } catch (e) { fail('public_push', e); }
  };


  /* ═══ Listing + navigation layer: home / collection / search ══════════════
     The pages whose whole job is routing get their own funnel - scroll reach,
     cards actually seen, what gets clicked, WHERE people leave to, and who
     leaves nowhere. Every step is a beacon field with automatic add/checkout
     joins:
       <sfc>:view                          - pageview of that surface
       <sfc>:scroll_25|50|75               - scroll quartiles
       <sfc>:cards_8|16|24|32              - unique cards half-seen (ladder)
       <sfc>:card_click, click_top4|5_12|13plus
       <sfc>:to_pdp|to_plp|to_srch|to_cart|to_other - outbound destination
       <sfc>:left_cold|left_warm           - left with NO outbound; cold never
                                             scrolled a quarter, warm browsed
       entry:home|plp|srch|pdp|other       - the session's landing surface
     sfc ∈ home|plp|srch. The dead mark rides pagehide only: visibilitychange
     also fires on tab-switches and would call returning visitors dead. */
  /* which DEVICE's page is this? Main-PDP only (the same population as the
     sessions series). The key is the handle tail from the first brand token,
     squashed to alphanumerics - the checkout pixel derives the SAME canonical
     form from line-item titles, so views and sold units join per device. */
  function initDeviceStep() {
    if (s(CFG.pageType) !== 'product' || s(CFG.templateSuffix)) { return; }
    var h = (location.pathname.split('/products/')[1] || '').split('?')[0].toLowerCase();
    if (!h) { return; }
    var m = h.match(/(iphone|samsung|galaxy|xiaomi|redmi|huawei|oneplus|honor|pixel|oppo|realme|nothing)[-a-z0-9]*$/);
    if (!m) { return; }
    var canon = m[0].replace(/[^a-z0-9]/g, '').slice(0, 24);
    if (canon.length < 4) { return; }
    setTimeout(function () { push('mf_nav_step', { mf_step: 'dev:' + canon }); }, 0);
  }

  function initListingNav() {
    /* Feed mode: the document does not scroll and the classic grids are empty -
       quart() would instantly write home:/plp:/srch: scroll marks with inverted
       meaning. The feed:* family measures those pages instead. */
    if (document.getElementById('mff')) { return; }
    var MAP = { index: 'home', collection: 'plp', search: 'srch' };
    var sfc = MAP[s(CFG.pageType)] || '';
    function nstep(step) { push('mf_nav_step', { mf_step: step }); }

    /* deferred a tick: this module boots before the beacon module, and a
       synchronous push here would fire while beaconTap is still null */
    setTimeout(function () {
      try {
        if (!sessionStorage.getItem('mf_entry')) {
          sessionStorage.setItem('mf_entry', '1');
          nstep('entry:' + (sfc || (s(CFG.pageType) === 'product' ? 'pdp' : 'other')));
        }
      } catch (e) {}
      if (sfc) { nstep(sfc + ':view'); }
    }, 0);

    if (!sfc) { return; }

    /* scroll quartiles; a page shorter than the viewport is 100% seen. The
       left_cold/left_warm split must NOT inherit that convention (a zero-result
       search would make every bounce 'warm'), so real engagement is tracked
       separately: an actual >=25% scroll position on a scrollable page. */
    var sq = {};
    var engagedScroll = false;
    var t0 = new Date().getTime();
    function quart() {
      var d = D.documentElement;
      var scrollable = (d.scrollHeight || 0) - (W.innerHeight || 0);
      var pct = scrollable <= 0 ? 100
        : Math.round(((W.pageYOffset || d.scrollTop || 0) / scrollable) * 100);
      if (scrollable > 0 && pct >= 25) { engagedScroll = true; }
      var marks = [25, 50, 75];
      for (var i = 0; i < marks.length; i++) {
        if (pct >= marks[i] && !sq[marks[i]]) { sq[marks[i]] = 1; nstep(sfc + ':scroll_' + marks[i]); }
      }
    }
    W.addEventListener('scroll', function () { quart(); }, { passive: true });
    setTimeout(quart, 0);

    /* the header's search overlay server-renders 4 hidden a.dcard cards on EVERY
       page, ahead of the grid in DOM order - counting them shifts every position
       by 4 and pollutes the seen-ladder. Grid cards = dcards OUTSIDE the header
       and the drawer, full stop. */
    function isGridCard(el) {
      return !(el.closest && el.closest('#shopify-section-header, #shopify-section-mini-cart'));
    }
    function gridCards() {
      var all = D.querySelectorAll('a.dcard');
      var out = [];
      for (var i = 0; i < all.length; i++) { if (isGridCard(all[i])) { out.push(all[i]); } }
      return out;
    }

    /* unique cards actually half-seen, cumulative ladder like cart depth */
    if (typeof W.IntersectionObserver === 'function' && typeof W.WeakSet === 'function') {
      var seenSet = new W.WeakSet();
      var seenCards = 0;
      var ladder = {};
      var io = new W.IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting || seenSet.has(entries[i].target)) { continue; }
          seenSet.add(entries[i].target);
          seenCards++;
          var rungs = [8, 16, 24, 32];
          for (var r = 0; r < rungs.length; r++) {
            if (seenCards >= rungs[r] && !ladder[rungs[r]]) {
              ladder[rungs[r]] = 1;
              nstep(sfc + ':cards_' + rungs[r]);
            }
          }
        }
      }, { threshold: 0.5 });
      var hookCards = function () {
        var cards = gridCards();
        for (var i = 0; i < cards.length; i++) { io.observe(cards[i]); }
      };
      hookCards();
      var mt = null;
      new MutationObserver(function () {
        if (mt) { clearTimeout(mt); }
        mt = setTimeout(hookCards, 500);
      }).observe(D.body, { childList: true, subtree: true });
    }

    /* clicks: card + position bucket, plus every outbound internal link
       classified by destination; the drawer checkout button counts as
       outbound too or every buyer who checks out from here reads as dead */
    var outbound = false;
    D.documentElement.addEventListener('click', function (ev) {
      if (!ev.isTrusted) { return; }
      var tgt = ev.target;
      if (tgt && tgt.closest && tgt.closest('button[name="checkout"], .checkout-button')) {
        outbound = true;
        nstep(sfc + ':to_cart');
        return;
      }
      var a = tgt && tgt.closest && tgt.closest('a[href]');
      if (!a) { return; }
      var href = a.getAttribute('href') || '';
      if (!href || href.charAt(0) === '#' || href.indexOf('javascript:') === 0) { return; }
      if (a.host && a.host !== W.location.host) { return; }
      /* a[data-action] anchors are JS controls the theme preventDefaults (filter
         chips, clear-filters) - no navigation happens, so neither outbound nor
         card metrics may count them. Capture phase cannot see defaultPrevented,
         the convention is the reliable signal. */
      if (a.hasAttribute('data-action')) { return; }
      if (a.classList && a.classList.contains('dcard') && isGridCard(a)) {
        nstep(sfc + ':card_click');
        var cards = gridCards();
        for (var i = 0; i < cards.length; i++) {
          if (cards[i] === a) {
            nstep(sfc + (i < 4 ? ':click_top4' : i < 12 ? ':click_5_12' : ':click_13plus'));
            break;
          }
        }
      }
      var pth = a.pathname || '';
      var dest = pth.indexOf('/products/') >= 0 ? 'to_pdp'
        : pth.indexOf('/collections') >= 0 ? 'to_plp'
        : pth.indexOf('/search') >= 0 ? 'to_srch'
        : (pth.indexOf('/cart') >= 0 || pth.indexOf('/checkout') >= 0) ? 'to_cart'
        : 'to_other';
      outbound = true;
      nstep(sfc + ':' + dest);
    }, true);

    /* warm = actually browsed: real scroll engagement, or >=10s dwell on a page
       too short to scroll. Known undercount: exits that fire only
       visibilitychange (iOS home button) carry no mark - uniform across the
       three surfaces, so the split stays comparable. */
    var deadSent = false;
    W.addEventListener('pagehide', function () {
      if (deadSent || outbound) { return; }
      deadSent = true;
      var warm = engagedScroll || (new Date().getTime() - t0) >= 10000;
      nstep(sfc + (warm ? ':left_warm' : ':left_cold'));
    }, false);
  }

  function boot() {
    try { initMenu(); } catch (e) { diag('menu_init_fail', e && e.message); }
    try { initPdpFunnel(); } catch (e2) { diag('pdp_init_fail', e2 && e2.message); }
    try { initSelectItem(); } catch (e3) { diag('select_item_init_fail', e3 && e3.message); }
    try { initRhodePdp(); } catch (e4) { diag('rhode_init_fail', e4 && e4.message); }
    try { initCartDrawer(); } catch (e5) { diag('cart_init_fail', e5 && e5.message); }
    try { initSearch(); } catch (e6) { diag('search_init_fail', e6 && e6.message); }
    try { initScrollDepth(); } catch (e7) { diag('scroll_init_fail', e7 && e7.message); }
    try { initGallery(); } catch (e9) { diag('gallery_init_fail', e9 && e9.message); }
    try { initBlockDepth(); } catch (e10) { diag('block_init_fail', e10 && e10.message); }
    try { initListingNav(); } catch (e11) { diag('nav_init_fail', e11 && e11.message); }
    try { initSessionBeacon(); } catch (e8) { diag('beacon_init_fail', e8 && e8.message); }
    /* AFTER the session beacon: its mf_nav_step consumer must exist before the
       device step is pushed - dispatched earlier, the step fell into the void */
    try { initDeviceStep(); } catch (e12) { diag('dev_init_fail', e12 && e12.message); }
  }

  if (D.readyState === 'loading') {
    D.addEventListener('DOMContentLoaded', boot, false);
  } else {
    boot();
  }
})();
